export const global_marketlist = {
  "1": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2",
    "group": "all|score|regular_play"
  },
  "2": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Te kwalificeren",
    "group": "all|score|cup_tie"
  },
  "3": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welk team wint de finale",
    "group": "all|score|cup_tie"
  },
  "4": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welk team wint de strijd om de 3e plaats",
    "group": "all|score|cup_tie"
  },
  "5": {
    "14": "{$competitor1} reguliere speeltijd",
    "15": "{$competitor2} reguliere speeltijd",
    "16": "{$competitor1} verlenging",
    "17": "{$competitor2} verlenging",
    "18": "{$competitor1} strafschoppen",
    "19": "{$competitor2} strafschoppen",
    "name": "Manier om te winnen",
    "group": "all|score|cup_tie"
  },
  "6": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welk team trapt af",
    "group": "all|misc"
  },
  "7": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Rest van de Match",
    "group": "all|score|regular_play"
  },
  "8": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{goalnr} doelpunt",
    "group": "all|score|regular_play"
  },
  "9": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Laatste doelpunt",
    "group": "all|score|regular_play"
  },
  "10": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "Dubbele kans",
    "group": "all|score|regular_play"
  },
  "11": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Draw no bet",
    "group": "all|score|regular_play"
  },
  "12": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "{$competitor1} no bet",
    "group": "all|score|regular_play"
  },
  "13": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "{$competitor2} no bet",
    "group": "all|score|regular_play"
  },
  "14": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "16": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap",
    "group": "all|score|regular_play"
  },
  "18": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal",
    "group": "all|score|regular_play"
  },
  "19": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal",
    "group": "all|score|regular_play"
  },
  "20": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal",
    "group": "all|score|regular_play"
  },
  "26": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven",
    "group": "all|score|regular_play"
  },
  "27": {
    "70": "oneven",
    "72": "even",
    "name": "{$competitor1} even/oneven",
    "group": "all|score|regular_play"
  },
  "28": {
    "70": "oneven",
    "72": "even",
    "name": "{$competitor2} even/oneven",
    "group": "all|score|regular_play"
  },
  "29": {
    "74": "ja",
    "76": "nee",
    "name": "Beide teams scoren",
    "group": "all|score|regular_play"
  },
  "30": {
    "784": "geen",
    "788": "alleen {$competitor1}",
    "790": "alleen {$competitor2}",
    "792": "beide teams",
    "name": "Welk team scoort",
    "group": "all|score|regular_play"
  },
  "31": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} houdt doel schoon",
    "group": "all|score|regular_play"
  },
  "32": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} houdt doel schoon",
    "group": "all|score|regular_play"
  },
  "33": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint zonder tegengoal",
    "group": "all|score|regular_play"
  },
  "34": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint zonder tegengoal",
    "group": "all|score|regular_play"
  },
  "35": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nee",
    "82": "X & ja",
    "84": "X & nee",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nee",
    "name": "1x2 & beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "36": {
    "90": "boven {total} & ja",
    "92": "{total} - & ja",
    "94": "boven {total} & nee",
    "96": "{total} - & nee",
    "name": "Totaal & beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "37": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & totaal",
    "group": "all|regular_play|combo|incl_ot"
  },
  "41": {
    "110": "0:0",
    "114": "1:0",
    "116": "2:0",
    "118": "3:0",
    "120": "4:0",
    "122": "5:0",
    "124": "6:0",
    "126": "0:1",
    "128": "1:1",
    "130": "2:1",
    "132": "3:1",
    "134": "4:1",
    "136": "5:1",
    "138": "0:2",
    "140": "1:2",
    "142": "2:2",
    "144": "3:2",
    "146": "4:2",
    "148": "0:3",
    "150": "1:3",
    "152": "2:3",
    "154": "3:3",
    "156": "0:4",
    "158": "1:4",
    "160": "2:4",
    "162": "0:5",
    "164": "1:5",
    "166": "0:6",
    "name": "Juiste uitslag {!score}",
    "group": "all|score|regular_play"
  },
  "45": {
    "274": "0:0",
    "276": "1:0",
    "278": "2:0",
    "280": "3:0",
    "282": "4:0",
    "284": "0:1",
    "286": "1:1",
    "288": "2:1",
    "290": "3:1",
    "292": "4:1",
    "294": "0:2",
    "296": "1:2",
    "298": "2:2",
    "300": "3:2",
    "302": "4:2",
    "304": "0:3",
    "306": "1:3",
    "308": "2:3",
    "310": "3:3",
    "312": "4:3",
    "314": "0:4",
    "316": "1:4",
    "318": "2:4",
    "320": "3:4",
    "322": "4:4",
    "324": "ander",
    "name": "Juiste uitslag",
    "group": "all|score|regular_play"
  },
  "46": {
    "326": "0:0 0:0",
    "328": "0:0 0:1",
    "330": "0:0 0:2",
    "332": "0:0 0:3",
    "334": "0:0 1:0",
    "336": "0:0 1:1",
    "338": "0:0 1:2",
    "340": "0:0 2:0",
    "342": "0:0 2:1",
    "344": "0:0 3:0",
    "346": "0:0 4+",
    "348": "0:1 0:1",
    "350": "0:1 0:2",
    "352": "0:1 0:3",
    "354": "0:1 1:1",
    "356": "0:1 1:2",
    "358": "0:1 2:1",
    "360": "0:1 4+",
    "362": "0:2 0:2",
    "364": "0:2 0:3",
    "366": "0:2 1:2",
    "368": "0:2 4+",
    "370": "0:3 0:3",
    "372": "0:3 4+",
    "374": "1:0 1:0",
    "376": "1:0 1:1",
    "378": "1:0 1:2",
    "380": "1:0 2:0",
    "382": "1:0 2:1",
    "384": "1:0 3:0",
    "386": "1:0 4+",
    "388": "1:1 1:1",
    "390": "1:1 1:2",
    "392": "1:1 2:1",
    "394": "1:1 4+",
    "396": "1:2 1:2",
    "398": "1:2 4+",
    "400": "2:0 2:0",
    "402": "2:0 2:1",
    "404": "2:0 3:0",
    "406": "2:0 4+",
    "408": "2:1 2:1",
    "410": "2:1 4+",
    "412": "3:0 3:0",
    "414": "3:0 4+",
    "416": "4+ 4+",
    "name": "Correcte rust/eindstand",
    "group": "all|score|regular_play"
  },
  "47": {
    "418": "{$competitor1}/{$competitor1}",
    "420": "{$competitor1}/X",
    "422": "{$competitor1}/{$competitor2}",
    "424": "X/{$competitor1}",
    "426": "X/X",
    "428": "X/{$competitor2}",
    "430": "{$competitor2}/{$competitor1}",
    "432": "{$competitor2}/X",
    "434": "{$competitor2}/{$competitor2}",
    "name": "Rust/eindstand",
    "group": "all|score|regular_play"
  },
  "48": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint beide helften",
    "group": "all|score|regular_play"
  },
  "49": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint beide helften",
    "group": "all|score|regular_play"
  },
  "50": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint minstens een helft",
    "group": "all|score|regular_play"
  },
  "51": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint minstens een helft",
    "group": "all|score|regular_play"
  },
  "52": {
    "436": "eerste helft",
    "438": "tweede helft",
    "440": "gelijk",
    "name": "Helft met de meeste doelpunten",
    "group": "all|score|regular_play"
  },
  "53": {
    "436": "eerste helft",
    "438": "tweede helft",
    "440": "gelijk",
    "name": "{$competitor1} wint helft met de meeste doelpunten",
    "group": "all|score|regular_play"
  },
  "54": {
    "436": "eerste helft",
    "438": "tweede helft",
    "440": "gelijk",
    "name": "{$competitor2} wint helft met de meeste doelpunten",
    "group": "all|score|regular_play"
  },
  "55": {
    "806": "nee/nee",
    "808": "ja/nee",
    "810": "ja/ja",
    "812": "nee/ja",
    "name": "Beide teams scoren in beide helften",
    "group": "all|score|regular_play"
  },
  "56": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} scoort in beide helften",
    "group": "all|score|regular_play"
  },
  "57": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} scoort in beide helften",
    "group": "all|score|regular_play"
  },
  "58": {
    "74": "ja",
    "76": "nee",
    "name": "Beide helften {total} +",
    "group": "all|score|regular_play"
  },
  "59": {
    "74": "ja",
    "76": "nee",
    "name": "Beide helften {total} -",
    "group": "all|score|regular_play"
  },
  "60": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1e helft - 1x2",
    "group": "all|score|1st_half"
  },
  "61": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1e helft - Rest van de Match",
    "group": "all|score|1st_half"
  },
  "62": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "1e helft - {!goalnr} doelpunt",
    "group": "all|score|1st_half"
  },
  "63": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "1e helft - dubbele kans",
    "group": "all|score|1st_half"
  },
  "64": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1e helft - draw no bet",
    "group": "all|score|1st_half"
  },
  "65": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1e helft - handicap {hcp}",
    "group": "all|score|1st_half"
  },
  "66": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1e helft - handicap",
    "group": "all|score|1st_half"
  },
  "68": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1e helft - totaal",
    "group": "all|score|1st_half"
  },
  "69": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1e helft - {$competitor1} totaal",
    "group": "all|score|1st_half"
  },
  "70": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1e helft - {$competitor2} totaal",
    "group": "all|score|1st_half"
  },
  "74": {
    "70": "oneven",
    "72": "even",
    "name": "1e helft - even/oneven",
    "group": "all|score|1st_half"
  },
  "75": {
    "74": "ja",
    "76": "nee",
    "name": "1e helft - beide teams scoren",
    "group": "all|score|1st_half"
  },
  "76": {
    "74": "ja",
    "76": "nee",
    "name": "1e helft - {$competitor1} houdt doel schoon",
    "group": "all|score|1st_half"
  },
  "77": {
    "74": "ja",
    "76": "nee",
    "name": "1e helft - {$competitor2} houdt doel schoon",
    "group": "all|score|1st_half"
  },
  "78": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nee",
    "82": "X & ja",
    "84": "X & nee",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nee",
    "name": "1e helft - 1x2 & beide teams scoren",
    "group": "all|combo|1st_half"
  },
  "79": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "1e helft - 1x2 & totaal",
    "group": "all|combo|1st_half"
  },
  "80": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "1e helft - juiste uitslag {!score}",
    "group": "all|score|1st_half"
  },
  "81": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "ander",
    "name": "1e helft - juiste uitslag",
    "group": "all|score|1st_half"
  },
  "83": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2e helft - 1x2",
    "group": "all|score|2nd_half"
  },
  "84": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "2e helft - {goalnr} doelpunt",
    "group": "all|score|2nd_half"
  },
  "85": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "2e helft - dubbele kans",
    "group": "all|score|2nd_half"
  },
  "86": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2e helft - draw no bet",
    "group": "all|score|2nd_half"
  },
  "87": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "2e helft - handicap {hcp}",
    "group": "all|score|2nd_half"
  },
  "88": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2e helft - handicap",
    "group": "all|score|2nd_half"
  },
  "90": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "2e helft - totaal",
    "group": "all|score|2nd_half"
  },
  "91": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "2e helft - {$competitor1} totaal",
    "group": "all|score|2nd_half"
  },
  "92": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "2e helft - {$competitor2} totaal",
    "group": "all|score|2nd_half"
  },
  "94": {
    "70": "oneven",
    "72": "even",
    "name": "2e helft - even/oneven",
    "group": "all|score|2nd_half"
  },
  "95": {
    "74": "ja",
    "76": "nee",
    "name": "2e helft - beide teams scoren",
    "group": "all|score|2nd_half"
  },
  "96": {
    "74": "ja",
    "76": "nee",
    "name": "2e helft - {$competitor1} houdt doel schoon",
    "group": "all|score|2nd_half"
  },
  "97": {
    "74": "ja",
    "76": "nee",
    "name": "2e helft - {$competitor2} houdt doel schoon",
    "group": "all|score|2nd_half"
  },
  "98": {
    "546": "0:0",
    "548": "0:1",
    "550": "0:2",
    "552": "1:0",
    "554": "1:1",
    "556": "1:2",
    "558": "2:0",
    "560": "2:1",
    "562": "2:2",
    "564": "ander",
    "name": "2e helft - juiste uitslag",
    "group": "all|score|2nd_half"
  },
  "100": {
    "584": "1-15",
    "586": "16-30",
    "588": "31-45",
    "590": "46-60",
    "592": "61-75",
    "594": "76-90",
    "596": "geen",
    "name": "Wanneer wordt het {goalnr} doelpunt gescoord (15 min interval)",
    "group": "all|score|regular_play"
  },
  "101": {
    "598": "1-10",
    "600": "11-20",
    "602": "21-30",
    "604": "31-40",
    "606": "41-50",
    "608": "51-60",
    "610": "61-70",
    "612": "71-80",
    "614": "81-90",
    "616": "geen",
    "name": "Wanneer wordt het {goalnr} doelpunt gescoord (10 min interval)",
    "group": "all|score|regular_play"
  },
  "102": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minuten - 1x2 van {from} tot {to}",
    "group": "all|score|15_min"
  },
  "103": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "15 minuten - {goalnr} doelpunt van {from} tot {to}",
    "group": "all|score|15_min"
  },
  "104": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "15 minuten - totaal van {from} tot {to}",
    "group": "all|score|15_min"
  },
  "105": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minuten - 1x2 van {from} tot {to}",
    "group": "all|score|10_min"
  },
  "106": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "10 minuten - {goalnr} doelpunt van {from} tot {to}",
    "group": "all|score|10_min"
  },
  "107": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "10 minuten - totaal van {from} tot {to}",
    "group": "all|score|10_min"
  },
  "108": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minuten - 1x2 van {from} tot {to}",
    "group": "all|score|5_min"
  },
  "109": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "5 minuten - {goalnr} doelpunt van {from} tot {to}",
    "group": "all|score|5_min"
  },
  "110": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "5 minuten - totaal van {from} tot {to}",
    "group": "all|score|5_min"
  },
  "112": {
    "74": "ja",
    "76": "nee",
    "name": "Verlenging & doelpunt",
    "group": "all|combo|ot"
  },
  "113": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Verlenging - 1x2",
    "group": "all|score|ot"
  },
  "114": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Verlenging - welk team wint het restant",
    "group": "all|score|ot"
  },
  "115": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Verlenging - {goalnr} doelpunt",
    "group": "all|score|ot"
  },
  "116": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Verlenging - totaal",
    "group": "all|score|ot"
  },
  "117": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Verlenging - handicap",
    "group": "all|score|ot"
  },
  "118": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "Verlenging - juiste uitslag {!score}",
    "group": "all|score|ot"
  },
  "119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Eerste helft verlenging - 1x2",
    "group": "all|score|ot_1st_half"
  },
  "120": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Eerste helft verlenging - handicap",
    "group": "all|score|ot_1st_half"
  },
  "121": {
    "618": "0:0",
    "620": "1:0",
    "622": "2:0",
    "624": "0:1",
    "626": "1:1",
    "628": "0:2",
    "name": "Eerste helft verlenging - juiste uitslag {!score}",
    "group": "all|score|ot_1st_half"
  },
  "122": {
    "74": "ja",
    "76": "nee",
    "name": "Zullen er strafschoppen nodig zijn",
    "group": "all|score|incl_ot"
  },
  "123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Strafschoppenserie - winnaar",
    "group": "all|score|pen_so"
  },
  "124": {
    "74": "ja",
    "76": "nee",
    "name": "Strafschoppenserie - {penaltynr} penalty benut",
    "group": "all|score|pen_so"
  },
  "125": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Strafschoppenserie - {goalnr} doelpunt",
    "group": "all|score|pen_so"
  },
  "126": {
    "630": "{$competitor1} met 1",
    "632": "{$competitor1} met 2",
    "634": "{$competitor1} met 3+",
    "636": "{$competitor2} met 1",
    "638": "{$competitor2} met 2",
    "640": "{$competitor2} met 3+",
    "name": "Strafschoppenserie - winstmarge",
    "group": "all|score|pen_so"
  },
  "127": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Strafschoppenserie - totaal",
    "group": "all|score|pen_so"
  },
  "128": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Strafschoppenserie - {$competitor1} totaal",
    "group": "all|score|pen_so"
  },
  "129": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Strafschoppenserie - {$competitor2} totaal",
    "group": "all|score|pen_so"
  },
  "131": {
    "70": "oneven",
    "72": "even",
    "name": "Strafschoppenserie - even/oneven",
    "group": "all|score|pen_so"
  },
  "132": {
    "70": "oneven",
    "72": "even",
    "name": "Strafschoppenserie - {$competitor1} even/oneven",
    "group": "all|score|pen_so"
  },
  "133": {
    "70": "oneven",
    "72": "even",
    "name": "Strafschoppenserie - {$competitor2} even/oneven",
    "group": "all|score|pen_so"
  },
  "134": {
    "656": "{$competitor1} & {total} -",
    "658": "{$competitor2} & {total} -",
    "660": "{$competitor1} & boven {total}",
    "662": "{$competitor2} & boven {total}",
    "name": "Strafschoppenserie - winnaar & totaal",
    "group": "all|combo|pen_so"
  },
  "135": {
    "1767": "0:1",
    "1768": "0:2",
    "1769": "0:3",
    "1770": "1:0",
    "1771": "1:2",
    "1772": "1:3",
    "1773": "1:4",
    "1774": "2:0",
    "1775": "2:1",
    "1776": "2:3",
    "1777": "2:4",
    "1778": "3:0",
    "1779": "3:1",
    "1780": "3:2",
    "1781": "3:4",
    "1782": "3:5",
    "1783": "4:1",
    "1784": "4:2",
    "1785": "4:3",
    "1786": "4:5",
    "1787": "5:3",
    "1788": "5:4",
    "1789": "ander",
    "name": "Strafschoppenserie - juiste uitslag",
    "group": "all|score|pen_so"
  },
  "136": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Kaarten 1x2",
    "group": "all|regular_play|bookings"
  },
  "137": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{bookingnr} kaart",
    "group": "all|regular_play|bookings"
  },
  "138": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal booking points",
    "group": "all|regular_play|bookings"
  },
  "139": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal kaarten",
    "group": "all|regular_play|bookings"
  },
  "140": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal kaarten {$competitor1}",
    "group": "all|regular_play|bookings"
  },
  "141": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal kaarten {$competitor2}",
    "group": "all|regular_play|bookings"
  },
  "142": {
    "710": "0-3",
    "712": "4",
    "714": "5",
    "716": "6",
    "718": "7",
    "720": "8",
    "722": "9",
    "724": "10",
    "726": "11",
    "728": "12+",
    "name": "Exact aantal kaarten",
    "group": "all|regular_play|bookings"
  },
  "143": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "Exact aantal kaarten {$competitor1}",
    "group": "all|regular_play|bookings"
  },
  "144": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "Exact aantal kaarten {$competitor2}",
    "group": "all|regular_play|bookings"
  },
  "146": {
    "74": "ja",
    "76": "nee",
    "name": "Uitsluitingen",
    "group": "all|regular_play|bookings"
  },
  "147": {
    "74": "ja",
    "76": "nee",
    "name": "Uitsluitingen {$competitor1}",
    "group": "all|regular_play|bookings"
  },
  "148": {
    "74": "ja",
    "76": "nee",
    "name": "Uitsluitingen {$competitor2}",
    "group": "all|regular_play|bookings"
  },
  "149": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Eerste helft - kaarten 1x2",
    "group": "all|1st_half|bookings"
  },
  "150": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - {bookingnr} kaart",
    "group": "all|1st_half|bookings"
  },
  "151": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal booking points",
    "group": "all|1st_half|bookings"
  },
  "152": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal kaarten",
    "group": "all|1st_half|bookings"
  },
  "153": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal kaarten {$competitor1}",
    "group": "all|1st_half|bookings"
  },
  "154": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal kaarten {$competitor2}",
    "group": "all|1st_half|bookings"
  },
  "155": {
    "1760": "0",
    "1761": "1",
    "1762": "2",
    "1763": "3",
    "1764": "4",
    "1765": "5",
    "1766": "6+",
    "name": "Eerste helft - exact aantal kaarten",
    "group": "all|1st_half|bookings"
  },
  "156": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Eerste helft - exact aantal kaarten {$competitor1}",
    "group": "all|1st_half|bookings"
  },
  "157": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Eerste helft - exact aantal kaarten {$competitor2}",
    "group": "all|1st_half|bookings"
  },
  "159": {
    "74": "ja",
    "76": "nee",
    "name": "Eerste helft - uitsluitingen",
    "group": "all|1st_half|bookings"
  },
  "160": {
    "74": "ja",
    "76": "nee",
    "name": "Eerste helft - uitsluitingen {$competitor1}",
    "group": "all|1st_half|bookings"
  },
  "161": {
    "74": "ja",
    "76": "nee",
    "name": "Eerste helft - uitsluitingen {$competitor2}",
    "group": "all|1st_half|bookings"
  },
  "162": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Hoekschop 1x2",
    "group": "all|regular_play|corners"
  },
  "163": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{cornernr} hoekschop",
    "group": "all|regular_play|corners"
  },
  "164": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Laatste hoekschop",
    "group": "all|regular_play|corners"
  },
  "165": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Hoekschop handicap",
    "group": "all|regular_play|corners"
  },
  "166": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal hoekschoppen",
    "group": "all|regular_play|corners"
  },
  "167": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal hoekschoppen {$competitor1}",
    "group": "all|regular_play|corners"
  },
  "168": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal hoekschoppen {$competitor2}",
    "group": "all|regular_play|corners"
  },
  "172": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven aantal hoekschoppen",
    "group": "all|regular_play|corners"
  },
  "173": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Eerste helft - hoekschop 1x2",
    "group": "all|1st_half|corners"
  },
  "174": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - {cornernr} hoekschop",
    "group": "all|1st_half|corners"
  },
  "175": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - laatste hoekschop",
    "group": "all|1st_half|corners"
  },
  "176": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Eerste helft - hoekschop handicap",
    "group": "all|1st_half|corners"
  },
  "177": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal hoekschoppen",
    "group": "all|1st_half|corners"
  },
  "178": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal hoekschoppen {$competitor1}",
    "group": "all|1st_half|corners"
  },
  "179": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal hoekschoppen {$competitor2}",
    "group": "all|1st_half|corners"
  },
  "180": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "Eerste helft - Exact aantal hoekschoppen {$competitor1}",
    "group": "all|1st_half|corners"
  },
  "181": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "Eerste helft - Exact aantal hoekschoppen {$competitor2}",
    "group": "all|1st_half|corners"
  },
  "183": {
    "70": "oneven",
    "72": "even",
    "name": "Eerste helft - even/oneven aantal hoekschoppen",
    "group": "all|1st_half|corners"
  },
  "184": {
    "814": "doelpunt {$competitor1} & {$competitor1}",
    "816": "doelpunt {$competitor1} & gelijkspel",
    "818": "doelpunt {$competitor1} & {$competitor2}",
    "820": "doelpunt {$competitor2} & {$competitor1}",
    "822": "doelpunt {$competitor2} & gelijkspel",
    "824": "doelpunt {$competitor2} & {$competitor2}",
    "826": "geen doelpunt",
    "name": "{goalnr} doelpuntl & 1x2",
    "group": "all|regular_play|combo"
  },
  "186": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winnaar",
    "group": "all|score|regular_play"
  },
  "187": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Game handicap",
    "group": "all|score|regular_play"
  },
  "188": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Set handicap",
    "group": "all|score|regular_play"
  },
  "189": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal games",
    "group": "all|score|regular_play"
  },
  "190": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal games {$competitor1}",
    "group": "all|score|regular_play"
  },
  "191": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal games {$competitor2}",
    "group": "all|score|regular_play"
  },
  "192": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint een set",
    "group": "all|score|regular_play"
  },
  "193": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint een set",
    "group": "all|score|regular_play"
  },
  "194": {
    "74": "ja",
    "76": "nee",
    "name": "Een set zonder game tegen",
    "group": "all|score|regular_play"
  },
  "195": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een tiebreak nodig zijn",
    "group": "all|score|regular_play"
  },
  "198": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven aantal games",
    "group": "all|score|regular_play"
  },
  "201": {
    "861": "{$competitor1}/{$competitor1}",
    "862": "{$competitor2}/{$competitor1}",
    "863": "{$competitor1}/{$competitor2}",
    "864": "{$competitor2}/{$competitor2}",
    "name": "Dubbel resultaat (eerste set/match)",
    "group": "all|score|regular_play"
  },
  "202": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set - winnaar",
    "group": "all|score|set"
  },
  "203": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{setnr} set - game handicap",
    "group": "all|score|set"
  },
  "204": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal aantal games",
    "group": "all|score|set"
  },
  "205": {
    "70": "oneven",
    "72": "even",
    "name": "{setnr} set - even/oneven aantal games",
    "group": "all|score|set"
  },
  "206": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set - zal er een tiebreak nodig zijn",
    "group": "all|score|set"
  },
  "207": {
    "865": "6:0",
    "866": "6:1",
    "867": "6:2",
    "868": "6:3",
    "869": "6:4",
    "870": "7:5",
    "871": "7:6",
    "872": "0:6",
    "873": "1:6",
    "874": "2:6",
    "875": "3:6",
    "876": "4:6",
    "877": "5:7",
    "878": "6:7",
    "name": "{setnr} set - juiste uitslag",
    "group": "all|score|set"
  },
  "208": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set - race naar {games} games",
    "group": "all|score|set"
  },
  "209": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{setnr} set - {gamenrX} en {gamenrY} game winnaar",
    "group": "all|score|game"
  },
  "210": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set game {gamenr} - winnaar",
    "group": "all|score|game"
  },
  "211": {
    "882": "4",
    "883": "5",
    "884": "6",
    "885": "7+",
    "name": "{setnr} set game {gamenr} - exact aantal punten",
    "group": "all|score|game"
  },
  "212": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set game {gamenr} - naar deuce",
    "group": "all|score|game"
  },
  "213": {
    "70": "oneven",
    "72": "even",
    "name": "{setnr} set game {gamenr} - even/oneven aantal punten",
    "group": "all|score|game"
  },
  "214": {
    "886": "{$competitor1} tot 0",
    "887": "{$competitor1} tot 15",
    "888": "{$competitor1} tot 30",
    "889": "{$competitor1} tot 40",
    "890": "{$competitor2} tot 0",
    "891": "{$competitor2} tot 15",
    "892": "{$competitor2} tot 30",
    "893": "{$competitor2} tot 40",
    "name": "{setnr} set game {gamenr} - juiste score",
    "group": "all|score|game"
  },
  "215": {
    "894": "{%server} tot 0",
    "895": "{%server} tot 15",
    "896": "{%server} tot 30",
    "897": "{%server} tot 40",
    "898": "break",
    "name": "{setnr} set game {gamenr} - juiste score of break",
    "group": "all|score|game"
  },
  "216": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set game {gamenr} - race naar {pointnr} punten",
    "group": "all|score|points"
  },
  "217": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{setnr} set game {gamenr} - winnaar eerste {pointnr} punten",
    "group": "all|score|points"
  },
  "218": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set game {gamenr} - {pointnr} punt",
    "group": "all|score|points"
  },
  "219": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winnaar (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "220": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er verlenging nodig zijn",
    "group": "all|score|regular_play"
  },
  "221": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{scorenr} score (verlenging inbegrepen)",
    "group": "all"
  },
  "222": {
    "901": "touchdown",
    "902": "veldgoal",
    "903": "ander",
    "904": "geen",
    "name": "{scorenr} type score (verlenging inbegrepen)",
    "group": "all"
  },
  "223": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "224": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "225": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "226": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "US totaal (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "227": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "228": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "229": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "230": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race naar {pointnr} punten (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "231": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Tweede helft - handicap (verlenging inbegrepen)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "232": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Tweede helft - totaal (verlenging inbegrepen)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "234": {
    "920": "Eerste kwart",
    "921": "Tweede kwart",
    "922": "Derde kwart",
    "923": "Vierde kwart",
    "924": "gelijk",
    "name": "Kwart met de hoogste score",
    "group": "all|score|regular_play"
  },
  "235": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{quarternr} kwart - 1x2",
    "group": "all|score|quarter"
  },
  "236": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{quarternr} kwart - totaal",
    "group": "all|score|quarter"
  },
  "237": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Punten handicap",
    "group": "all|score|regular_play"
  },
  "238": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal punten",
    "group": "all|score|regular_play"
  },
  "245": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{gamenr} game - winnaar",
    "group": "all|score|game"
  },
  "246": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{gamenr} game - punten handicap",
    "group": "all|score|game"
  },
  "247": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{gamenr} game - totaal aantal punten",
    "group": "all|score|game"
  },
  "248": {
    "70": "oneven",
    "72": "even",
    "name": "{gamenr} game - even/oneven",
    "group": "all|score|game"
  },
  "250": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{gamenr} game - race naar {pointnr} punten",
    "group": "all|score|game"
  },
  "251": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winnaar (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "252": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (extra innings inbegrepen)",
    "group": "all"
  },
  "253": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Welk team wint het restant van de wedstrijd (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "254": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "255": {
    "630": "{$competitor1} met 1",
    "632": "{$competitor1} met 2",
    "634": "{$competitor1} met 3+",
    "636": "{$competitor2} met 1",
    "638": "{$competitor2} met 2",
    "640": "{$competitor2} met 3+",
    "name": "Winstmarge (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "256": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "257": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "258": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "259": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "US totaal (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "260": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "261": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "262": {
    "939": "{total} -",
    "940": "exact {total}",
    "941": "boven {total}",
    "name": "Totaal (boven-exact-onder) (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "264": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "265": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "1x2 & totaal (extra innings inbegrepen)",
    "group": "all|combo|incl_ei"
  },
  "266": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{runnr} run (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "267": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race naar {runnr} runs (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "268": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een extra inning nodig zijn",
    "group": "all|score|regular_play"
  },
  "269": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} komt aan slag in de 9e inning",
    "group": "all|score|regular_play"
  },
  "270": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Team dat meer innings wint",
    "group": "all|score|regular_play"
  },
  "271": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Team met de inning met de hoogste score",
    "group": "all|score|regular_play"
  },
  "272": {
    "951": "1e inning",
    "952": "2e inning",
    "953": "3e inning",
    "954": "4e inning",
    "955": "5e inning",
    "956": "6e inning",
    "957": "7e inning",
    "958": "8e inning",
    "959": "9e inning",
    "960": "gelijk",
    "name": "Inning met de hoogste score",
    "group": "all|score|regular_play"
  },
  "273": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Exact aantal runs in de inning met de hoogste score",
    "group": "all|score|regular_play"
  },
  "274": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Inning 1 tot 5 - 1x2",
    "group": "all|score|5_innings"
  },
  "275": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Inning 1 tot 5 - handicap",
    "group": "all|score|5_innings"
  },
  "276": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning 1 tot 5 - totaal",
    "group": "all|score|5_innings"
  },
  "277": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning 1 tot 5 - {$competitor1} totaal",
    "group": "all|score|5_innings"
  },
  "278": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning 1 tot 5 - {$competitor2} totaal",
    "group": "all|score|5_innings"
  },
  "279": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Eerste helft (top) Inning 1 tot 5 - 1x2",
    "group": "all|score|4.5_innings"
  },
  "280": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Eerste helft (top) Inning 1 tot 5 - handicap",
    "group": "all|score|4.5_innings"
  },
  "281": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft (top) Inning 1 tot 5 - totaal",
    "group": "all|score|4.5_innings"
  },
  "282": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft (top) Inning 1 tot 5 - {$competitor1} totaal",
    "group": "all|score|4.5_innings"
  },
  "283": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft (top) Inning 1 tot 5 - {$competitor2} totaal",
    "group": "all|score|4.5_innings"
  },
  "284": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning {from} tot {to} - totaal",
    "group": "all|score|3_innings"
  },
  "285": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning {from} tot {to} - {$competitor1} totaal",
    "group": "all|score|3_innings"
  },
  "286": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Inning {from} tot {to} - {$competitor2} totaal",
    "group": "all|score|3_innings"
  },
  "287": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} inning - 1x2",
    "group": "all|score|inning"
  },
  "288": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - totaal",
    "group": "all|score|inning"
  },
  "289": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welk team wint de sprongbal",
    "group": "all|misc"
  },
  "291": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{pointnr} punt (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "292": {
    "973": "{$competitor1} & boven {total}",
    "974": "{$competitor2} & boven {total}",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Winnaar & totaal (verlenging inbegrepen)",
    "group": "all|combo|incl_ot"
  },
  "293": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Tweede helft - 1x2 (verlenging inbegrepen)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "294": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Tweede helft - draw no bet (verlenging inbegrepen)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "295": {
    "70": "oneven",
    "72": "even",
    "name": "Tweede helft - even/oneven (verlenging inbegrepen)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "297": {
    "939": "{total} -",
    "940": "exact {total}",
    "941": "boven {total}",
    "name": "Totaal (boven-exact-onder)",
    "group": "all|score|regular_play"
  },
  "300": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race naar {pointnr} punten",
    "group": "all|score|regular_play"
  },
  "301": {
    "1002": "{$competitor1} met 3+",
    "1003": "{$competitor2} met 3+",
    "1004": "ander",
    "name": "{quarternr} kwart - winstmarge",
    "group": "all|score|quarter"
  },
  "302": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{quarternr} kwart - draw no bet",
    "group": "all|score|quarter"
  },
  "303": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{quarternr} kwart - handicap",
    "group": "all|score|quarter"
  },
  "304": {
    "70": "oneven",
    "72": "even",
    "name": "{quarternr} kwart - even/oneven",
    "group": "all|score|quarter"
  },
  "305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{quarternr} kwart - race naar {pointnr} punten",
    "group": "all|score|quarter"
  },
  "309": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{setnr} set - punten handicap",
    "group": "all|score|set"
  },
  "310": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal aantal punten",
    "group": "all|score|set"
  },
  "311": {
    "70": "oneven",
    "72": "even",
    "name": "{setnr} set - even/oneven",
    "group": "all|score|set"
  },
  "312": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set - {pointnr} punt",
    "group": "all|score|set"
  },
  "313": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set - race naar {pointnr} punten",
    "group": "all|score|set"
  },
  "314": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal sets",
    "group": "all|score|regular_play"
  },
  "315": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{setnr} set - 1x2",
    "group": "all|score|set"
  },
  "316": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set - draw no bet",
    "group": "all|score|set"
  },
  "317": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{setnr} set - handicap {hcp}",
    "group": "all|score|set"
  },
  "318": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - {$competitor1} totaal",
    "group": "all|score|set"
  },
  "319": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - {$competitor2} totaal",
    "group": "all|score|set"
  },
  "322": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set end {endnr} - winnaar",
    "group": "all|score|end"
  },
  "323": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set end {endnr} - totaal",
    "group": "all|score|end"
  },
  "324": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "{setnr} set end {endnr} - exact aantal punten",
    "group": "all|score|end"
  },
  "325": {
    "70": "oneven",
    "72": "even",
    "name": "{setnr} set end {endnr} - even/oneven",
    "group": "all|score|end"
  },
  "326": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Map handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "327": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Map handicap",
    "group": "all|score|regular_play"
  },
  "328": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal maps",
    "group": "all|score|regular_play"
  },
  "330": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - winnaar (overtime inbegrepen)",
    "group": "all|score|map_incl_ot"
  },
  "331": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr} map - round handicap (overtime inbegrepen)",
    "group": "all|score|map_incl_ot"
  },
  "332": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map - totaal rounds (overtime inbegrepen)",
    "group": "all|score|map_incl_ot"
  },
  "333": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} kill",
    "group": "all|kills|map"
  },
  "334": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{mapnr} map - 1x2",
    "group": "all|score|map"
  },
  "335": {
    "74": "ja",
    "76": "nee",
    "name": "{mapnr} map - zal er overtime nodig zijn",
    "group": "all|score|map"
  },
  "337": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map knife round - winnaar",
    "group": "all|round"
  },
  "338": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - round {roundnr} - winnaar",
    "group": "all|round"
  },
  "340": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winnaar (super over inbegrepen)",
    "group": "all|score|incl_so"
  },
  "341": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een super over nodig zijn",
    "group": "all|score|regular_play"
  },
  "342": {
    "74": "ja",
    "76": "nee",
    "name": "Wordt het een gelijkspel",
    "group": "all|score|regular_play"
  },
  "343": {
    "1031": "caught",
    "1032": "bowled",
    "1033": "lbw",
    "1034": "run out",
    "1035": "stumped",
    "1036": "ander",
    "name": "{inningnr} innings - {dismissalnr} dismissal methode",
    "group": "all|dismissal|innings"
  },
  "344": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{inningnr} innings - {dismissalnr} dismissal methode (gelimiteerd)",
    "group": "all|dismissal|innings"
  },
  "347": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "{inningnr} innings - team met de over met hoogste score",
    "group": "all|score|innings"
  },
  "349": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal {$competitor1} bij {dismissalnr} dismissal",
    "group": "all|score|innings"
  },
  "350": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal {$competitor2} bij {dismissalnr} dismissal",
    "group": "all|score|innings"
  },
  "351": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} innings overs 0 tot {overnr} - 1x2",
    "group": "all|score|x_overs"
  },
  "352": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings overs 0 tot {overnr} - totaal {$competitor1}",
    "group": "all|score|x_overs"
  },
  "353": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings overs 0 tot {overnr} - totaal {$competitor2}",
    "group": "all|score|x_overs"
  },
  "356": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings over {overnr} - totaal {$competitor1}",
    "group": "all|score|over"
  },
  "357": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings over {overnr} - totaal {$competitor2}",
    "group": "all|score|over"
  },
  "358": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "eerste over - totaal",
    "group": "all|score|over"
  },
  "359": {
    "70": "oneven",
    "72": "even",
    "name": "{inningnr} innings over {overnr} - {$competitor1} even/oneven",
    "group": "all|score|over"
  },
  "360": {
    "70": "oneven",
    "72": "even",
    "name": "{inningnr} innings over {overnr} - {$competitor2} even/oneven",
    "group": "all|score|over"
  },
  "361": {
    "70": "oneven",
    "72": "even",
    "name": "eerste over - even/oneven",
    "group": "all|score|over"
  },
  "362": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings over {overnr} - totaal {$competitor1} {deliverynr} delivery",
    "group": "all|score|delivery"
  },
  "363": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings over {overnr} - totaal {$competitor2} {deliverynr} delivery",
    "group": "all|score|delivery"
  },
  "365": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Set handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "366": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Leg handicap",
    "group": "all|score|regular_play"
  },
  "367": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal legs",
    "group": "all|score|regular_play"
  },
  "368": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven sets",
    "group": "all|score|regular_play"
  },
  "370": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{setnr} set - welke speler wint het restant",
    "group": "all|score|set"
  },
  "371": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{setnr} set - leg handicap",
    "group": "all|score|set"
  },
  "372": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal legs",
    "group": "all|score|set"
  },
  "373": {
    "70": "oneven",
    "72": "even",
    "name": "{setnr} set - even/oneven legs",
    "group": "all|score|set"
  },
  "375": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{setnr} set leg {legnr} - winnaar",
    "group": "all|score|leg"
  },
  "376": {
    "1039": "boven {total}",
    "1040": "{total} -",
    "name": "{setnr} set leg {legnr} - totaal darts",
    "group": "all|score|leg"
  },
  "377": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{setnr} set leg {legnr} - speler met de hoogste score na {visitnr} beurten",
    "group": "all|score|visit"
  },
  "378": {
    "1044": "0-89",
    "1045": "90-100",
    "1046": "101+",
    "name": "{setnr} set leg {legnr} - score in de {visitnr} beurt",
    "group": "all|score|visit"
  },
  "379": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set leg {legnr} - checkout score {score}+",
    "group": "all|leg|checkout"
  },
  "380": {
    "1049": "rood",
    "1050": "groen",
    "name": "{setnr} set leg {legnr} - checkout kleur",
    "group": "all|leg|checkout"
  },
  "381": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "Meeste 180s",
    "group": "all|regular_play|180s"
  },
  "382": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{xth} speler gooit een 180",
    "group": "all|regular_play|180s"
  },
  "383": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "180s handicap",
    "group": "all|regular_play|180s"
  },
  "384": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal 180s",
    "group": "all|regular_play|180s"
  },
  "385": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal 180s {$competitor1}",
    "group": "all|regular_play|180s"
  },
  "386": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal 180s {$competitor2}",
    "group": "all|regular_play|180s"
  },
  "387": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{setnr} set - meeste 180s",
    "group": "all|set|180s"
  },
  "388": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal aantal 180s",
    "group": "all|set|180s"
  },
  "389": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal aantal 180s {$competitor1}",
    "group": "all|set|180s"
  },
  "390": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal aantal 180s {$competitor2}",
    "group": "all|set|180s"
  },
  "391": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set leg {legnr} - willekeurige speler gooit een 180",
    "group": "all|leg|180s"
  },
  "392": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set leg {legnr} - {$competitor1} gooit een 180",
    "group": "all|leg|180s"
  },
  "393": {
    "74": "ja",
    "76": "nee",
    "name": "{setnr} set leg {legnr} - {$competitor2} gooit een 180",
    "group": "all|leg|180s"
  },
  "395": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - winnaar",
    "group": "all|map"
  },
  "396": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} aegis",
    "group": "all|map|structures"
  },
  "397": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} tower",
    "group": "all|map|structures"
  },
  "398": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} barracks",
    "group": "all|map|structures"
  },
  "401": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Juiste score {!score}",
    "group": "all|score|regular_play"
  },
  "402": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Eerste helft - juiste score {!score}",
    "group": "all|score|1st_half"
  },
  "404": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{goalnr} doelpunt (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "405": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race naar {goalnr} doelpunten (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "406": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winnaar (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "407": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{goalnr} doelpunt (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "408": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "409": {
    "630": "{$competitor1} met 1",
    "632": "{$competitor1} met 2",
    "634": "{$competitor1} met 3+",
    "636": "{$competitor2} met 1",
    "638": "{$competitor2} met 2",
    "640": "{$competitor2} met 3+",
    "name": "Winstmarge (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "410": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "411": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "412": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "413": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "US totaal (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "414": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "415": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "419": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "420": {
    "1475": "beide",
    "1476": "alleen {$competitor1}",
    "1477": "alleen {$competitor2}",
    "name": "Welk team scoort (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "421": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} houdt doel schoon (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "422": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} houdt doel schoon (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "423": {
    "1478": "doelpunt {$competitor1} & {$competitor1}",
    "1479": "doelpunt {$competitor1} & {$competitor2}",
    "1480": "doelpunt {$competitor2} & {$competitor1}",
    "1481": "doelpunt {$competitor2} & {$competitor2}",
    "name": "{goalnr} doelpunt & winnaar (verlenging en strafschoppen inbegrepen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "424": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "1x2 & totaal (verlenging en strafschoppen inbegrepen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "425": {
    "1706": "{$competitor1} & ja",
    "1708": "{$competitor1} & nee",
    "1709": "{$competitor2} & ja",
    "1710": "{$competitor2} & nee",
    "name": "1x2 & beide teams scoren (verlenging en strafschoppen inbegrepen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "426": {
    "1482": "{$competitor1} & {$competitor1}",
    "1483": "X & {$competitor1}",
    "1484": "{$competitor2} & {$competitor1}",
    "1485": "{$competitor1} & {$competitor2}",
    "1486": "X & {$competitor2}",
    "1487": "{$competitor2} & {$competitor2}",
    "name": "{periodnr} periode 1x2 & winnaar (verlenging en strafschoppen inbegrepen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "427": {
    "1488": "1:0",
    "1489": "2:0",
    "1490": "3:0",
    "1491": "4:0",
    "1492": "5:0",
    "1493": "0:1",
    "1494": "2:1",
    "1495": "3:1",
    "1496": "4:1",
    "1497": "5:1",
    "1498": "0:2",
    "1499": "1:2",
    "1500": "3:2",
    "1501": "4:2",
    "1502": "5:2",
    "1503": "0:3",
    "1504": "1:3",
    "1505": "2:3",
    "1506": "4:3",
    "1507": "5:3",
    "1508": "0:4",
    "1509": "1:4",
    "1510": "2:4",
    "1511": "3:4",
    "1512": "5:4",
    "1513": "0:5",
    "1514": "1:5",
    "1515": "2:5",
    "1516": "3:5",
    "1517": "4:5",
    "1518": "ander",
    "name": "Juiste score (verlenging en strafschoppen inbegrepen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "429": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & gelijkspel",
    "1533": "X & gelijkspel",
    "1534": "{$competitor2} & gelijkspel",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{periodnr} periode 1x2 & 1x2",
    "group": "all|regular_play|combo"
  },
  "430": {
    "1538": "0:0",
    "1539": "1:0",
    "1540": "2:0",
    "1541": "3:0",
    "1542": "4:0",
    "1543": "5:0",
    "1544": "6:0",
    "1545": "7:0",
    "1546": "8:0",
    "1547": "0:1",
    "1548": "1:1",
    "1549": "2:1",
    "1550": "3:1",
    "1551": "4:1",
    "1552": "5:1",
    "1553": "6:1",
    "1554": "7:1",
    "1555": "0:2",
    "1556": "1:2",
    "1557": "2:2",
    "1558": "3:2",
    "1559": "4:2",
    "1560": "5:2",
    "1561": "6:2",
    "1562": "0:3",
    "1563": "1:3",
    "1564": "2:3",
    "1565": "3:3",
    "1566": "4:3",
    "1567": "5:3",
    "1568": "0:4",
    "1569": "1:4",
    "1570": "2:4",
    "1571": "3:4",
    "1572": "4:4",
    "1573": "0:5",
    "1574": "1:5",
    "1575": "2:5",
    "1576": "3:5",
    "1577": "0:6",
    "1578": "1:6",
    "1579": "2:6",
    "1580": "0:7",
    "1581": "1:7",
    "1582": "0:8",
    "name": "Juiste score {!score}",
    "group": "all|score|regular_play"
  },
  "431": {
    "1584": "0:0",
    "1585": "1:0",
    "1586": "2:0",
    "1587": "3:0",
    "1588": "4:0",
    "1589": "5:0",
    "1590": "0:1",
    "1591": "1:1",
    "1592": "2:1",
    "1593": "3:1",
    "1594": "4:1",
    "1595": "5:1",
    "1596": "0:2",
    "1597": "1:2",
    "1598": "2:2",
    "1599": "3:2",
    "1600": "4:2",
    "1601": "5:2",
    "1602": "0:3",
    "1603": "1:3",
    "1604": "2:3",
    "1605": "3:3",
    "1606": "4:3",
    "1607": "5:3",
    "1608": "0:4",
    "1609": "1:4",
    "1610": "2:4",
    "1611": "3:4",
    "1612": "4:4",
    "1613": "5:4",
    "1614": "0:5",
    "1615": "1:5",
    "1616": "2:5",
    "1617": "3:5",
    "1618": "4:5",
    "1619": "5:5",
    "1620": "ander",
    "name": "Juiste score",
    "group": "all|score|regular_play"
  },
  "432": {
    "1621": "1e periode",
    "1622": "2e periode",
    "1623": "3e periode",
    "1624": "gelijk",
    "name": "Periode met de hoogste score",
    "group": "all|score|regular_play"
  },
  "433": {
    "1621": "1e periode",
    "1622": "2e periode",
    "1623": "3e periode",
    "1624": "gelijk",
    "name": "Periode met de hoogste score van {$competitor1}",
    "group": "all|score|regular_play"
  },
  "434": {
    "1621": "1e periode",
    "1622": "2e periode",
    "1623": "3e periode",
    "1624": "gelijk",
    "name": "Periode met de hoogste score van {$competitor2}",
    "group": "all|score|regular_play"
  },
  "435": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint alle periodes",
    "group": "all|score|regular_play"
  },
  "436": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint alle periodes",
    "group": "all|score|regular_play"
  },
  "437": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint een periode",
    "group": "all|score|regular_play"
  },
  "438": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2}wint een periode",
    "group": "all|score|regular_play"
  },
  "439": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1}scoort in alle periodes",
    "group": "all|score|regular_play"
  },
  "440": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} scoort in alle periodes",
    "group": "all|score|regular_play"
  },
  "441": {
    "74": "ja",
    "76": "nee",
    "name": "Alle periodes boven {total}",
    "group": "all|score|regular_play"
  },
  "442": {
    "74": "ja",
    "76": "nee",
    "name": "Alle periodes {total} -",
    "group": "all|score|regular_play"
  },
  "443": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{periodnr} periode - 1x2",
    "group": "all|score|period"
  },
  "444": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{periodnr} periode - {goalnr} doelpunt",
    "group": "all|score|period"
  },
  "445": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{periodnr} periode - handicap {hcp}",
    "group": "all|score|period"
  },
  "446": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{periodnr} periode - totaal",
    "group": "all|score|period"
  },
  "447": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{periodnr} periode - totaal {$competitor1}",
    "group": "all|score|period"
  },
  "448": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{periodnr} periode - totaal {$competitor2}",
    "group": "all|score|period"
  },
  "452": {
    "74": "ja",
    "76": "nee",
    "name": "{periodnr} periode - beide teams scoren",
    "group": "all|score|period"
  },
  "453": {
    "784": "geen",
    "788": "alleen {$competitor1}",
    "790": "alleen {$competitor2}",
    "792": "beide teams",
    "name": "{periodnr} periode - welk team scoort",
    "group": "all|score|period"
  },
  "454": {
    "74": "ja",
    "76": "nee",
    "name": "{periodnr} periode - {$competitor1} houdt doel schoon",
    "group": "all|score|period"
  },
  "455": {
    "74": "ja",
    "76": "nee",
    "name": "{periodnr} periode - {$competitor2} houdt doel schoon",
    "group": "all|score|period"
  },
  "456": {
    "1630": "0:0",
    "1631": "1:0",
    "1632": "2:0",
    "1633": "0:1",
    "1634": "1:1",
    "1635": "2:1",
    "1636": "0:2",
    "1637": "1:2",
    "1638": "2:2",
    "1639": "ander",
    "name": "{periodnr} periode - juiste score",
    "group": "all|score|period"
  },
  "457": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{periodnr} periode - laatst scorende team",
    "group": "all|score|period"
  },
  "458": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{periodnr} periode - welk team wint het restant",
    "group": "all|score|period"
  },
  "459": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{periodnr} periode - draw no bet",
    "group": "all|score|period"
  },
  "460": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{periodnr} periode - handicap",
    "group": "all|score|period"
  },
  "462": {
    "70": "oneven",
    "72": "even",
    "name": "{periodnr} periode - even/oneven",
    "group": "all|score|period"
  },
  "463": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "Verlenging - dubbele kans",
    "group": "all|score|ot"
  },
  "464": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Verlenging - draw no bet",
    "group": "all|score|ot"
  },
  "465": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "Verlenging - {$competitor1} no bet",
    "group": "all|score|ot"
  },
  "466": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "Verlenging - {$competitor2} no bet",
    "group": "all|score|ot"
  },
  "467": {
    "1640": "{$competitor1} met try",
    "1641": "{$competitor1} met penalty",
    "1642": "{$competitor1} met drop goal",
    "1643": "{$competitor2} met try",
    "1644": "{$competitor2} met penalty",
    "1645": "{$competitor2} met drop goal",
    "name": "{scorenr} scoring play",
    "group": "all|score|regular_play"
  },
  "472": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - race naar {pointnr} punten",
    "group": "all|score|1st_half"
  },
  "473": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Try 1x2",
    "group": "all|regular_play|tries"
  },
  "474": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "Try dubbele kans",
    "group": "all|regular_play|tries"
  },
  "475": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Try draw no bet",
    "group": "all|regular_play|tries"
  },
  "476": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Try handicap {hcp}",
    "group": "all|regular_play|tries"
  },
  "477": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Try handicap",
    "group": "all|regular_play|tries"
  },
  "478": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal tries",
    "group": "all|regular_play|tries"
  },
  "479": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal tries {$competitor1}",
    "group": "all|regular_play|tries"
  },
  "480": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal tries {$competitor2}",
    "group": "all|regular_play|tries"
  },
  "481": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven aantal tries",
    "group": "all|regular_play|tries"
  },
  "482": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Eerste helft - try 1x2",
    "group": "all|1st_half|tries"
  },
  "483": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "Eerste helft - try dubbele kans",
    "group": "all|1st_half|tries"
  },
  "484": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Eerste helft - try draw no bet",
    "group": "all|1st_half|tries"
  },
  "485": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Eerste helft - try handicap {hcp}",
    "group": "all|1st_half|tries"
  },
  "486": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Eerste helft - try handicap",
    "group": "all|1st_half|tries"
  },
  "487": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal tries",
    "group": "all|1st_half|tries"
  },
  "488": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal tries {$competitor1}",
    "group": "all|1st_half|tries"
  },
  "489": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Eerste helft - totaal aantal tries {$competitor2}",
    "group": "all|1st_half|tries"
  },
  "490": {
    "70": "oneven",
    "72": "even",
    "name": "Eerste helft - even/oneven aantal tries",
    "group": "all|1st_half|tries"
  },
  "491": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Welke speler wint het restant van de wedstrijd",
    "group": "all|score|regular_play"
  },
  "492": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een beslissende frame nodig zijn",
    "group": "all|score|regular_play"
  },
  "493": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Frame handicap",
    "group": "all|score|regular_play"
  },
  "494": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal frames",
    "group": "all|score|regular_play"
  },
  "495": {
    "70": "oneven",
    "72": "even",
    "name": "Even/oneven aantal frames",
    "group": "all|score|regular_play"
  },
  "496": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race naar {framenr} frames",
    "group": "all|score|regular_play"
  },
  "497": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Frame {fromframe} tot {toframe} - {frames} opeenvolgende frames winnaar",
    "group": "all|score|x_frames"
  },
  "498": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Frame 1 tot {framenr} 1x2",
    "group": "all|score|x_frames"
  },
  "499": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr} frame - winnaar",
    "group": "all|score|frame"
  },
  "500": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{framenr} frame - punten handicap",
    "group": "all|score|frame"
  },
  "501": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{framenr} frame - totaal aantal punten",
    "group": "all|score|frame"
  },
  "502": {
    "70": "oneven",
    "72": "even",
    "name": "{framenr} frame - even/oneven",
    "group": "all|score|frame"
  },
  "503": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr} frame - race naar {pointnr} punten",
    "group": "all|score|frame"
  },
  "504": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr} frame - speler met de hoogste break",
    "group": "all|frame|break"
  },
  "505": {
    "1667": "0-49",
    "1668": "50-99",
    "1669": "100-119",
    "1670": "120-146",
    "1671": "147+",
    "name": "{framenr} frame - hoogste break",
    "group": "all|frame|break"
  },
  "506": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - break 100+",
    "group": "all|frame|break"
  },
  "507": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - {$competitor1} break 100+",
    "group": "all|frame|break"
  },
  "508": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - {$competitor2} break 100+",
    "group": "all|frame|break"
  },
  "509": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - break 50+",
    "group": "all|frame|break"
  },
  "510": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - {$competitor1} break 50+",
    "group": "all|frame|break"
  },
  "511": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - {$competitor2} break 50+",
    "group": "all|frame|break"
  },
  "512": {
    "74": "ja",
    "76": "nee",
    "name": "{framenr} frame - wordt er een foul gemaakt",
    "group": "all|score|frame"
  },
  "513": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr} frame - speler die de {xth} bal pot",
    "group": "all|score|frame"
  },
  "514": {
    "1672": "geel",
    "1673": "groen",
    "1674": "bruin",
    "1675": "blauw",
    "1676": "roze",
    "1677": "zwart",
    "name": "{framenr} frame - {xth} kleur gepot",
    "group": "all|score|frame"
  },
  "515": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr} frame - speler die de laatste bal pot",
    "group": "all|score|frame"
  },
  "516": {
    "1678": "rood",
    "1679": "geel",
    "1680": "groen",
    "1681": "bruin",
    "1682": "blauw",
    "1683": "roze",
    "1684": "zwart",
    "1685": "fout",
    "name": "{framenr} frame - laatste punten gescoord",
    "group": "all|score|frame"
  },
  "520": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{gamenr} game - {pointnr} punt",
    "group": "all|score|game"
  },
  "525": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een vierde set nodig zijn",
    "group": "all|score|regular_play"
  },
  "526": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een vijfde set nodig zijn",
    "group": "all|score|regular_play"
  },
  "527": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{setnr} set - handicap",
    "group": "all|score|set"
  },
  "528": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{setnr} set - totaal",
    "group": "all|score|set"
  },
  "529": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "{periodnr} periode - dubbele kans",
    "group": "all|score|period"
  },
  "530": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - {scorenr} score",
    "group": "all"
  },
  "538": {
    "1717": "X",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "540": {
    "1718": "{$competitor1}/gelijkspel & ja",
    "1719": "{$competitor1}/gelijkspel & nee",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nee",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nee",
    "name": "Dubbele kans (match) & beide teams scoren in eerste helft",
    "group": "all|regular_play|combo"
  },
  "541": {
    "1718": "{$competitor1}/gelijkspel & ja",
    "1719": "{$competitor1}/gelijkspel & nee",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nee",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nee",
    "name": "Dubbele kans (match) & beide teams scoren in tweede helft",
    "group": "all|regular_play|combo"
  },
  "542": {
    "1718": "{$competitor1}/gelijkspel & ja",
    "1719": "{$competitor1}/gelijkspel & nee",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nee",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nee",
    "name": "Eerste helft - dubbele kans & beide teams scoren",
    "group": "all|combo|1st_half"
  },
  "543": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nee",
    "82": "X & ja",
    "84": "X & nee",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nee",
    "name": "Tweede helft - 1x2 & beide teams scoren",
    "group": "all|combo|2nd_half"
  },
  "544": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "Tweede helft - 1x2 & totaal",
    "group": "all|combo|2nd_half"
  },
  "545": {
    "1718": "{$competitor1}/gelijkspel & ja",
    "1719": "{$competitor1}/gelijkspel & nee",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nee",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nee",
    "name": "Tweede helft - dubbele kans & beide teams scoren",
    "group": "all|combo|2nd_half"
  },
  "546": {
    "1718": "{$competitor1}/gelijkspel & ja",
    "1719": "{$competitor1}/gelijkspel & nee",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nee",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nee",
    "name": "Dubbele kans & beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "547": {
    "1724": "{$competitor1}/gelijkspel & {total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "X/{$competitor2} & {total} -",
    "1727": "{$competitor1}/gelijkspel & boven {total}",
    "1728": "{$competitor1}/{$competitor2} & boven {total}",
    "1729": "X/{$competitor2} & boven {total}",
    "name": "Dubbele kans & totaal",
    "group": "all|regular_play|combo"
  },
  "548": {
    "1730": "1-2",
    "1731": "1-3",
    "1732": "1-4",
    "1733": "1-5",
    "1734": "1-6",
    "1735": "2-3",
    "1736": "2-4",
    "1737": "2-5",
    "1738": "2-6",
    "1739": "3-4",
    "1740": "3-5",
    "1741": "3-6",
    "1742": "4-5",
    "1743": "4-6",
    "1744": "5-6",
    "1745": "7+",
    "1804": "geen doelpunt",
    "name": "Multigoals",
    "group": "all|score|regular_play"
  },
  "549": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "geen doelpunt",
    "name": "{$competitor1} multigoals",
    "group": "all|score|regular_play"
  },
  "550": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "geen doelpunt",
    "name": "{$competitor2} multigoals",
    "group": "all|score|regular_play"
  },
  "551": {
    "1750": "1:0, 2:0 of 3:0",
    "1751": "0:1, 0:2 of 0:3",
    "1752": "4:0, 5:0 of 6:0",
    "1753": "0:4, 0:5 of 0:6",
    "1754": "2:1, 3:1 of 4:1",
    "1755": "1:2, 1:3 of 1:4",
    "1756": "3:2, 4:2, 4:3 of 5:1",
    "1757": "2:3, 2:4, 3:4 of 1:5",
    "1758": "ander thuisoverwinning",
    "1759": "ander uitoverwinning",
    "1803": "X",
    "name": "Multiscores",
    "group": "all|score|regular_play"
  },
  "552": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "geen doelpunt",
    "name": "Eerste helft - multigoals",
    "group": "all|score|1st_half"
  },
  "553": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "geen doelpunt",
    "name": "Tweede helft - multigoals",
    "group": "all|score|2nd_half"
  },
  "554": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - kill draw no bet",
    "group": "all|kills|map"
  },
  "555": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr} map - kill handicap",
    "group": "all|kills|map"
  },
  "556": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} dragon",
    "group": "all|map|structures"
  },
  "557": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} baron",
    "group": "all|map|structures"
  },
  "558": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} inhibitor",
    "group": "all|map|structures"
  },
  "563": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Race naar {pointnr} punten",
    "group": "all|score|regular_play"
  },
  "565": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minutes - hoekschop 1x2 van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "566": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "15 minutes - {cornernr} hoekschop van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "567": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "15 minutes - hoekschop handicap van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "568": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "15 minutes - totaal aantal hoekschoppen van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "569": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "15 minutes - totaal aantal hoekschoppen {$competitor1} van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "570": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "15 minutes - totaal aantal hoekschoppen {$competitor2} van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "571": {
    "70": "oneven",
    "72": "even",
    "name": "15 minutes - even/oneven aantal hoekschoppen van {from} tot {to}",
    "group": "all|15_min|corners"
  },
  "572": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minutes - hoekschop 1x2 van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "573": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "10 minutes - {cornernr} hoekschop van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "574": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "10 minutes - hoekschop handicap van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "575": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "10 minutes - totaal aantal hoekschoppen van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "576": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "10 minutes - totaal aantal hoekschoppen {$competitor1} van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "577": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "10 minutes - totaal aantal hoekschoppen {$competitor2} van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "578": {
    "70": "oneven",
    "72": "even",
    "name": "10 minutes - even/oneven aantal hoekschoppen van {from} tot {to}",
    "group": "all|10_min|corners"
  },
  "579": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minutes - hoekschop 1x2 van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "580": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "5 minutes - {cornernr} hoekschop van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "581": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "5 minutes - hoekschop handicap van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "582": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "5 minutes - totaal aantal hoekschoppen van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "583": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "5 minutes - totaal aantal hoekschoppen {$competitor1} van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "584": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "5 minutes - totaal aantal hoekschoppen {$competitor2} van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "585": {
    "70": "oneven",
    "72": "even",
    "name": "5 minutes - even/oneven aantal hoekschoppen van {from} tot {to}",
    "group": "all|5_min|corners"
  },
  "586": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minutes - kaart 1x2 van {from} tot {to}",
    "group": "all|15_min|bookings"
  },
  "587": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "15 minutes - totaal aantal kaarten van {from} tot {to}",
    "group": "all|15_min|bookings"
  },
  "588": {
    "74": "ja",
    "76": "nee",
    "name": "15 minutes - uitsluiting van {from} tot {to}",
    "group": "all|15_min|bookings"
  },
  "589": {
    "74": "ja",
    "76": "nee",
    "name": "15 minutes - uitsluiting {$competitor1} van {from} tot {to}",
    "group": "all|15_min|bookings"
  },
  "590": {
    "74": "ja",
    "76": "nee",
    "name": "15 minutes - uitsluiting {$competitor2} van {from} tot {to}",
    "group": "all|15_min|bookings"
  },
  "591": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minutes - kaart 1x2 van {from} tot {to}",
    "group": "all|10_min|bookings"
  },
  "592": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "10 minutes - totaal aantal kaarten van {from} tot {to}",
    "group": "all|10_min|bookings"
  },
  "593": {
    "74": "ja",
    "76": "nee",
    "name": "10 minutes - uitsluiting van {from} tot {to}",
    "group": "all|10_min|bookings"
  },
  "594": {
    "74": "ja",
    "76": "nee",
    "name": "10 minutes - uitsluiting {$competitor1} van {from} tot {to}",
    "group": "all|10_min|bookings"
  },
  "595": {
    "74": "ja",
    "76": "nee",
    "name": "10 minutes - uitsluiting {$competitor2} van {from} tot {to}",
    "group": "all|10_min|bookings"
  },
  "596": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minutes - kaart 1x2 van {from} tot {to}",
    "group": "all|5_min|bookings"
  },
  "597": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "5 minutes - totaal aantal kaarten van {from} tot {to}",
    "group": "all|5_min|bookings"
  },
  "598": {
    "74": "ja",
    "76": "nee",
    "name": "5 minutes - uitsluiting van {from} tot {to}",
    "group": "all|5_min|bookings"
  },
  "599": {
    "74": "ja",
    "76": "nee",
    "name": "5 minutes - uitsluiting {$competitor1} van {from} tot {to}",
    "group": "all|5_min|bookings"
  },
  "600": {
    "74": "ja",
    "76": "nee",
    "name": "5 minutes - uitsluiting {$competitor2} van {from} tot {to}",
    "group": "all|5_min|bookings"
  },
  "601": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Race naar {cornernr} hoekschoppen",
    "group": "all|regular_play|corners"
  },
  "602": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Eerste helft - race naar {cornernr} hoekschoppen",
    "group": "all|1st_half|corners"
  },
  "603": {
    "1797": "hoog links",
    "1798": "laag links",
    "1799": "hoog midden",
    "1800": "laag midden",
    "1801": "hoog rechts",
    "1802": "laag rechts",
    "name": "{goalnr} doelpunt - strike zone",
    "group": "all|misc"
  },
  "604": {
    "74": "ja",
    "76": "nee",
    "name": "{penaltynr} strafschop benut",
    "group": "all|score|regular_play"
  },
  "605": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal",
    "group": "all|score|innings"
  },
  "606": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor1} totaal",
    "group": "all|score|innings"
  },
  "607": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor2} totaal",
    "group": "all|score|innings"
  },
  "608": {
    "70": "oneven",
    "72": "even",
    "name": "{inningnr} innings - even/oneven",
    "group": "all|score|innings"
  },
  "609": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team met het kwart met de hoogste score",
    "group": "all|score|regular_play"
  },
  "610": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "611": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{quarternr} kwart - 1x2 (verlenging inbegrepen)",
    "group": "all|score|quarter_incl_ot"
  },
  "612": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Draw no bet (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "613": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{quarternr} kwart - draw no bet (verlenging inbegrepen)",
    "group": "all|score|quarter_incl_ot"
  },
  "614": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{quarternr} kwart - handicap (verlenging inbegrepen)",
    "group": "all|score|quarter_incl_ot"
  },
  "615": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{quarternr} kwart - totaal (verlenging inbegrepen)",
    "group": "all|score|quarter_incl_ot"
  },
  "616": {
    "70": "oneven",
    "72": "even",
    "name": "{$competitor1} even/oneven (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "617": {
    "70": "oneven",
    "72": "even",
    "name": "{$competitor2} even/oneven (verlenging inbegrepen)",
    "group": "all|score|incl_ot"
  },
  "618": {
    "70": "oneven",
    "72": "even",
    "name": "Eerste helft - {$competitor1} even/oneven",
    "group": "all|score|1st_half"
  },
  "619": {
    "70": "oneven",
    "72": "even",
    "name": "Eerste helft - {$competitor2} even/oneven",
    "group": "all|score|1st_half"
  },
  "620": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - race naar {roundnr} rounds",
    "group": "all|score|map"
  },
  "621": {
    "70": "oneven",
    "72": "even",
    "name": "{mapnr} map - even/oneven rounds (verlenging inbegrepen)",
    "group": "all|score|map_incl_ot"
  },
  "622": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map - totaal headshots (verlenging inbegrepen)",
    "group": "all|map_incl_ot|kills"
  },
  "623": {
    "74": "ja",
    "76": "nee",
    "name": "{mapnr} map - komt er een ace (verlenging inbegrepen)",
    "group": "all|map_incl_ot|kills"
  },
  "626": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map round {roundnr} - totaal aantal kills",
    "group": "all|kills|round"
  },
  "627": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr} map round {roundnr} - kill handicap",
    "group": "all|kills|round"
  },
  "628": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map round {roundnr} - {killnr} kill",
    "group": "all|kills|round"
  },
  "629": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map round {roundnr} - totaal aantal kills {$competitor1}",
    "group": "all|kills|round"
  },
  "630": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map round {roundnr} - totaal aantal kills {$competitor2}",
    "group": "all|kills|round"
  },
  "631": {
    "74": "ja",
    "76": "nee",
    "name": "{mapnr} map round {roundnr} - bom geplaatst",
    "group": "all|round|bomb"
  },
  "632": {
    "74": "ja",
    "76": "nee",
    "name": "{mapnr} map round {roundnr} - bom ontmanteld",
    "group": "all|round|bomb"
  },
  "634": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team met de helft met de hoogste score",
    "group": "all|score|regular_play"
  },
  "638": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} totaal",
    "group": "all"
  },
  "639": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal fours",
    "group": "all"
  },
  "640": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal sixes",
    "group": "all"
  },
  "641": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings over {overnr} - {$competitor1} dismissal",
    "group": "all"
  },
  "642": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings over {overnr} - {$competitor2} dismissal",
    "group": "all"
  },
  "643": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} totaal aantal fours",
    "group": "all"
  },
  "644": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} totaal aantal sixes",
    "group": "all"
  },
  "645": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} innings over {overnr} - 1x2",
    "group": "all"
  },
  "646": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team met de hoogste score bij de {dismissalnr} dismissal",
    "group": "all"
  },
  "647": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste fours",
    "group": "all"
  },
  "648": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste sixes",
    "group": "all"
  },
  "649": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal dismissals {$competitor1}",
    "group": "all"
  },
  "650": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal dismissals {$competitor2}",
    "group": "all"
  },
  "651": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{inningnr} innings - {player} dismissal methode",
    "group": "all"
  },
  "652": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings over {overnr} - {$competitor1} boundary",
    "group": "all"
  },
  "653": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings over {overnr} - {$competitor2} boundary",
    "group": "all"
  },
  "654": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal run outs",
    "group": "all"
  },
  "655": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal extras",
    "group": "all"
  },
  "656": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "{inningnr} innings - {dismissalnr} partnership 1x2",
    "group": "all"
  },
  "657": {
    "1821": "{%player1}",
    "1822": "{%player2}",
    "name": "{inningnr} innings - {dismissalnr} slagman uit",
    "group": "all"
  },
  "658": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal fours {$competitor1}",
    "group": "all"
  },
  "659": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal fours {$competitor2}",
    "group": "all"
  },
  "660": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal sixes {$competitor1}",
    "group": "all"
  },
  "661": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal sixes {$competitor2}",
    "group": "all"
  },
  "662": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings - {player} dat een {milestone} scoort",
    "group": "all"
  },
  "663": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings overs 0 to {overnr} - totaal aantal dismissals {$competitor1}",
    "group": "all"
  },
  "664": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings overs 0 to {overnr} - totaal aantal dismissals {$competitor2}",
    "group": "all"
  },
  "665": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{daynr} day session {sessionnr} - totaal",
    "group": "all"
  },
  "666": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal extras {$competitor1}",
    "group": "all"
  },
  "667": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal extras {$competitor2}",
    "group": "all"
  },
  "668": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal run outs {$competitor1}",
    "group": "all"
  },
  "669": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal run outs {$competitor2}",
    "group": "all"
  },
  "670": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor1} totaal in de over met de hoogste score",
    "group": "all"
  },
  "671": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor2} totaal in de over met de hoogste score",
    "group": "all"
  },
  "680": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste extras",
    "group": "all"
  },
  "681": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste run outs",
    "group": "all"
  },
  "682": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal van de over met de hoogste score",
    "group": "all"
  },
  "686": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Slagman head2head (1x2)",
    "group": "all"
  },
  "687": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Werper head2head (1x2)",
    "group": "all"
  },
  "688": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "All-rounder head2head (1x2)",
    "group": "all"
  },
  "689": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Keeper head2head (1x2)",
    "group": "all"
  },
  "690": {
    "70": "oneven",
    "72": "even",
    "name": "{inningnr} innings - {$competitor1} even/oneven",
    "group": "all"
  },
  "691": {
    "70": "oneven",
    "72": "even",
    "name": "{inningnr} innings - {$competitor2} even/oneven",
    "group": "all"
  },
  "692": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings - {$competitor1} sluit af met een boundary",
    "group": "all"
  },
  "693": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings - {$competitor2} sluit af met een boundary",
    "group": "all"
  },
  "694": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welk team wint de toss",
    "group": "all"
  },
  "695": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal ducks",
    "group": "all"
  },
  "696": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal wides",
    "group": "all"
  },
  "697": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal dismissals",
    "group": "all"
  },
  "698": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Team met de beste slagman",
    "group": "all"
  },
  "699": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Team met de beste werper",
    "group": "all"
  },
  "700": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} innings - er wordt een {milestone} gescoord",
    "group": "all"
  },
  "701": {
    "74": "ja",
    "76": "nee",
    "name": "Er wordt een {milestone} gescoord",
    "group": "all"
  },
  "702": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Beste slagman totaal",
    "group": "all"
  },
  "703": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Rabbit totaal",
    "group": "all"
  },
  "704": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor1} totaal aantal wijdballen gegooid",
    "group": "all"
  },
  "705": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - {$competitor2} totaal aantal wijdballen gegooid",
    "group": "all"
  },
  "706": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal ducks {$competitor1}",
    "group": "all"
  },
  "707": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} innings - totaal aantal ducks {$competitor2}",
    "group": "all"
  },
  "708": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} totaal aantal dismissals",
    "group": "all"
  },
  "709": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totale speler performance",
    "group": "all"
  },
  "710": {
    "1813": "{$competitor1}",
    "1814": "geen van beide",
    "1815": "{$competitor2}",
    "name": "Welk team wint de toss en de wedstrijd",
    "group": "all"
  },
  "711": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} innings - 1x2",
    "group": "all"
  },
  "712": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste keeper catches",
    "group": "all"
  },
  "713": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste catches",
    "group": "all"
  },
  "714": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meeste stumpings",
    "group": "all"
  },
  "717": {
    "1816": "{%player1} ({+hcp})",
    "1817": "{%player2} ({-hcp})",
    "name": "Slagman head2head (handicap)",
    "group": "all"
  },
  "718": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{inningnr} innings - {dismissalnr} dismissal methode (uitgebreid)",
    "group": "all"
  },
  "723": {
    "74": "ja",
    "76": "nee",
    "name": "Komt er een rampage",
    "group": "all|regular_play|kills"
  },
  "724": {
    "74": "ja",
    "76": "nee",
    "name": "Komt er een ultra kill",
    "group": "all|regular_play|kills"
  },
  "725": {
    "1831": "00:00 - {(minute-1)}:59",
    "1832": "{minute}:00+",
    "name": "{mapnr} map - duration",
    "group": "all|map|progress"
  },
  "726": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map - totaal aantal kills",
    "group": "all|kills|map"
  },
  "727": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map - totaal aantal aegis",
    "group": "all|map|structures"
  },
  "728": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map - totaal aantal towers",
    "group": "all|map|structures"
  },
  "729": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr} map - aegis handicap",
    "group": "all|map|structures"
  },
  "730": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr} map - tower handicap",
    "group": "all|map|structures"
  },
  "731": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - race naar {xth} kills",
    "group": "all|kills|map"
  },
  "732": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - race naar {xth} net worth",
    "group": "all|map|progress"
  },
  "733": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - race naar level {xth}",
    "group": "all|map|progress"
  },
  "734": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{mapnr} map 10 minuten - totaal aantal kills van {from} tot {to}",
    "group": "all|10_min|kills"
  },
  "736": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map eerste helft - winnaar",
    "group": "all|score|map_1st_half"
  },
  "737": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Maximaal aantal opeenvolgende runs",
    "group": "all|score|regular_play"
  },
  "738": {
    "1823": "eerste helft 9e inning",
    "1824": "tweede helft 9e inning",
    "1825": "extra inning(s)",
    "name": "Wanneer wordt de wedstrijd beslist",
    "group": "all|score|regular_play"
  },
  "739": {
    "1826": "{!inningnr} inning",
    "1828": "{!(inningnr+1)} inning",
    "1829": "{!(inningnr+2)} inning",
    "1830": "andere inning of geen run",
    "name": "Wanneer wordt de {runnr} run gescoord (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "740": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal innings zonder score",
    "group": "all|score|regular_play"
  },
  "741": {
    "74": "ja",
    "76": "nee",
    "name": "Beide teams {total} + (extra innings inbegrepen)",
    "group": "all|score|incl_ei"
  },
  "742": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & gelijkspel",
    "1533": "X & gelijkspel",
    "1534": "{$competitor2} & gelijkspel",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "Eerste {innings} innings 1x2 & 1x2 (extra innings inbegrepen)",
    "group": "all|combo|incl_ei"
  },
  "743": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings {from} tot {to} - 1x2",
    "group": "all|score|3_innings"
  },
  "744": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings {from} tot {to} - handicap",
    "group": "all|score|3_innings"
  },
  "745": {
    "70": "oneven",
    "72": "even",
    "name": "Innings {from} tot {to} - even/oneven",
    "group": "all|score|3_innings"
  },
  "746": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{inningnr} inning - handicap",
    "group": "all|score|inning"
  },
  "747": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - {$competitor1} totaal",
    "group": "all|score|inning"
  },
  "748": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - {$competitor2} totaal",
    "group": "all|score|inning"
  },
  "749": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} inning - {$competitor1} scoort",
    "group": "all|score|inning"
  },
  "750": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} inning - {$competitor2} scoort",
    "group": "all|score|inning"
  },
  "751": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} inning - beide teams scoren",
    "group": "all|score|inning"
  },
  "752": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - {xth} shrine",
    "group": "all|map|structures"
  },
  "753": {
    "9": "{$competitor1} of X",
    "10": "{$competitor1} of {$competitor2}",
    "11": "X of {$competitor2}",
    "name": "{quarternr} kwart - dubbele kans",
    "group": "all|score|quarter"
  },
  "754": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{quarternr} kwart - welk team wint het restant",
    "group": "all|score|quarter"
  },
  "756": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{quarternr} kwart - {$competitor1} totaal",
    "group": "all|score|quarter"
  },
  "757": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{quarternr} kwart - {$competitor2} totaal",
    "group": "all|score|quarter"
  },
  "797": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - thuisspelende ploegen totaal",
    "group": "all|matchday"
  },
  "798": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - uitspelende ploegen totaal",
    "group": "all|matchday"
  },
  "799": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - totaa",
    "group": "all|matchday"
  },
  "800": {
    "1833": "thuisspelende teams",
    "1834": "X",
    "1835": "uitspelende teams",
    "name": "{$event} matchday {matchday} - meeste doelpunten thuis- of uitspelende ploegen",
    "group": "all|matchday"
  },
  "801": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - totaal aantal overwinningen thuisspelende ploeg",
    "group": "all|matchday"
  },
  "802": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - totaal aantal gelijke spelen",
    "group": "all|matchday"
  },
  "803": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$event} matchday {matchday} - totaal aantal overwinningen uitspelende ploeg",
    "group": "all|matchday"
  },
  "815": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr} map - assist draw no bet",
    "group": "all"
  },
  "816": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{inningnr} innings - {$competitor1} {dismissalnr} dismissal methode (uitgebreid)",
    "group": "all"
  },
  "817": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{inningnr} innings - {$competitor2} {dismissalnr} dismissal methode (uitgebreid)",
    "group": "all"
  },
  "818": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/gelijkspel & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "X/{$competitor1} & {total} -",
    "1840": "X/gelijkspel & {total} -",
    "1841": "X/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/gelijkspel & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & boven {total}",
    "1846": "{$competitor1}/gelijkspel & boven {total}",
    "1847": "{$competitor1}/{$competitor2} & boven {total}",
    "1848": "X/{$competitor1} & boven {total}",
    "1849": "X/gelijkspel & boven {total}",
    "1850": "X/{$competitor2} & boven {total}",
    "1851": "{$competitor2}/{$competitor1} & boven {total}",
    "1852": "{$competitor2}/gelijkspel & boven {total}",
    "1853": "{$competitor2}/{$competitor2} & boven {total}",
    "name": "Ruststand/eindstand & totaal",
    "group": "all|regular_play|combo"
  },
  "819": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/gelijkspel & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "X/{$competitor1} & {total} -",
    "1840": "X/gelijkspel & {total} -",
    "1841": "X/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/gelijkspel & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & boven {total}",
    "1846": "{$competitor1}/gelijkspel & boven {total}",
    "1847": "{$competitor1}/{$competitor2} & boven {total}",
    "1848": "X/{$competitor1} & boven {total}",
    "1849": "X/gelijkspel & boven {total}",
    "1850": "X/{$competitor2} & boven {total}",
    "1851": "{$competitor2}/{$competitor1} & boven {total}",
    "1852": "{$competitor2}/gelijkspel & boven {total}",
    "1853": "{$competitor2}/{$competitor2} & boven {total}",
    "name": "Ruststand/eindstand & eerste helft totaal",
    "group": "all|regular_play|combo"
  },
  "820": {
    "1854": "X/gelijkspel & 0",
    "1855": "{$competitor1}/{$competitor1} & 1",
    "1856": "X/{$competitor1} & 1",
    "1857": "X/{$competitor2} & 1",
    "1858": "{$competitor2}/{$competitor2} & 1",
    "1859": "{$competitor1}/{$competitor1} & 2",
    "1860": "{$competitor1}/gelijkspel & 2",
    "1861": "X/{$competitor1} & 2",
    "1862": "X/gelijkspel & 2",
    "1863": "X/{$competitor2} & 2",
    "1864": "{$competitor2}/gelijkspel & 2",
    "1865": "{$competitor2}/{$competitor2} & 2",
    "1866": "{$competitor1}/{$competitor1} & 3",
    "1867": "{$competitor1}/{$competitor2} & 3",
    "1868": "X/{$competitor1} & 3",
    "1869": "X/{$competitor2} & 3",
    "1870": "{$competitor2}/{$competitor1} & 3",
    "1871": "{$competitor2}/{$competitor2} & 3",
    "1872": "{$competitor1}/{$competitor1} & 4",
    "1873": "{$competitor1}/gelijkspel & 4",
    "1874": "{$competitor1}/{$competitor2} & 4",
    "1875": "X/{$competitor1} & 4",
    "1876": "X/gelijkspel & 4",
    "1877": "X/{$competitor2} & 4",
    "1878": "{$competitor2}/{$competitor1} & 4",
    "1879": "{$competitor2}/gelijkspel & 4",
    "1880": "{$competitor2}/{$competitor2} & 4",
    "1881": "{$competitor1}/{$competitor1} & 5+",
    "1882": "{$competitor1}/gelijkspel & 5+",
    "1883": "{$competitor1}/{$competitor2} & 5+",
    "1884": "X/{$competitor1} & 5+",
    "1885": "X/gelijkspel & 5+",
    "1886": "X/{$competitor2} & 5+",
    "1887": "{$competitor2}/{$competitor1} & 5+",
    "1888": "{$competitor2}/gelijkspel & 5+",
    "1889": "{$competitor2}/{$competitor2} & 5+",
    "name": "Ruststand/eindstand & exact aantal doelpunten",
    "group": "all|regular_play|combo"
  },
  "821": {
    "70": "oneven",
    "72": "even",
    "name": "Som trekking even/oneven",
    "group": "all"
  },
  "822": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totale som trekking",
    "group": "all"
  },
  "824": {
    "70": "oneven",
    "72": "even",
    "name": "Reservebal even/oneven",
    "group": "all"
  },
  "825": {
    "70": "oneven",
    "72": "even",
    "name": "Som reservebal even/oneven",
    "group": "all"
  },
  "826": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Reservebal totaal",
    "group": "all"
  },
  "827": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Som reservebal totaal",
    "group": "all"
  },
  "828": {
    "74": "ja",
    "76": "nee",
    "name": "Eencijferige reservebal",
    "group": "all"
  },
  "829": {
    "74": "ja",
    "76": "nee",
    "name": "Reservebal gelijk aan willekeurige gewone bal",
    "group": "all"
  },
  "831": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totale som trekking (reservebal inbegrepen)",
    "group": "all"
  },
  "835": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor1} windex",
    "group": "all"
  },
  "836": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor2} windex",
    "group": "all"
  },
  "837": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor1}/{$competitor2} supremacy",
    "group": "all"
  },
  "838": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor2}/{$competitor1} supremacy",
    "group": "all"
  },
  "839": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor1} total spread",
    "group": "all"
  },
  "840": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor2} total spread",
    "group": "all"
  },
  "841": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor1} total spread bij {dismissalnr} dismissal",
    "group": "all"
  },
  "842": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor2} total spread bij {dismissalnr} dismissal",
    "group": "all"
  },
  "843": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} total spread",
    "group": "all"
  },
  "844": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs 0 tot {overnr} - {$competitor1} total spread",
    "group": "all"
  },
  "845": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs 0 tot {overnr} - {$competitor2} total spread",
    "group": "all"
  },
  "846": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings over {overnr} - {$competitor1} total spread",
    "group": "all"
  },
  "847": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings over {overnr} - {$competitor2} total spread",
    "group": "all"
  },
  "850": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint precies 1 set",
    "group": "all|score|regular_play"
  },
  "851": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint precies 1 set",
    "group": "all|score|regular_play"
  },
  "852": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint precies 2 sets",
    "group": "all|score|regular_play"
  },
  "853": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint precies 2 sets",
    "group": "all|score|regular_play"
  },
  "854": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} of boven {total}",
    "group": "all|regular_play|combo"
  },
  "855": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} of {total} -",
    "group": "all|regular_play|combo"
  },
  "856": {
    "74": "ja",
    "76": "nee",
    "name": "X of boven {total}",
    "group": "all|regular_play|combo"
  },
  "857": {
    "74": "ja",
    "76": "nee",
    "name": "X of {total} -",
    "group": "all|regular_play|combo"
  },
  "858": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} of boven {total}",
    "group": "all|regular_play|combo"
  },
  "859": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} of {total} -",
    "group": "all|regular_play|combo"
  },
  "860": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} of beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "861": {
    "74": "ja",
    "76": "nee",
    "name": "X of beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "862": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} of beide teams scoren",
    "group": "all|regular_play|combo"
  },
  "863": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} of een schoon doel",
    "group": "all|regular_play|combo"
  },
  "864": {
    "74": "ja",
    "76": "nee",
    "name": "X of een schoon doel",
    "group": "all|regular_play|combo"
  },
  "865": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} of een schoon doel",
    "group": "all|regular_play|combo"
  },
  "870": {
    "1893": "ander",
    "name": "Exacta",
    "group": "all"
  },
  "871": {
    "1893": "ander",
    "name": "Quinella",
    "group": "all"
  },
  "872": {
    "1893": "ander",
    "name": "Trifecta",
    "group": "all"
  },
  "873": {
    "1893": "ander",
    "name": "Trio",
    "group": "all"
  },
  "875": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - Totaal {$competitor1} bij {dismissalnr} dismissal",
    "group": "all"
  },
  "876": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - Totaal {$competitor2} bij {dismissalnr} dismissal",
    "group": "all"
  },
  "877": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - Totaal {$competitor1}",
    "group": "all"
  },
  "878": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - Totaal {$competitor2}",
    "group": "all"
  },
  "879": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} wint",
    "group": "all|score|regular_play"
  },
  "880": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} wint",
    "group": "all|score|regular_play"
  },
  "881": {
    "74": "ja",
    "76": "nee",
    "name": "We krijgen een winnaar",
    "group": "all|score|regular_play"
  },
  "882": {
    "74": "ja",
    "76": "nee",
    "name": "{%player} scoort (verlenging inbegrepen)",
    "group": "all|scorers|incl_ot"
  },
  "883": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1 minuut - totaal van {from} tot {to}",
    "group": "all|score|rapid_market"
  },
  "884": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1 minuut - totaal aantal hoekschoppen van {from} tot {to}",
    "group": "all|corners|rapid_market"
  },
  "885": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1 minuut - totaal aantal kaarten van {from} tot {to}",
    "group": "all|bookings|rapid_market"
  },
  "886": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1 minuut - totaal aantal buitenspelgevallen van {from} tot {to}",
    "group": "all|rapid_market|offsides"
  },
  "887": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "1 minuut - totaal aantal strafschoppen toegekend van {from} tot {to}",
    "group": "all|rapid_market|penalties"
  },
  "888": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & gelijkspel",
    "1896": "{%player} & {$competitor2}",
    "1897": "ander",
    "name": "Doelpuntenmaker & 1x2",
    "group": "all|regular_play|combo"
  },
  "889": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "ander",
    "name": "Doelpuntenmaker & juiste uitslag",
    "group": "all|regular_play|combo"
  },
  "890": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "ander",
    "name": "{!goalnr} doelpuntenmaker & juiste uitslag",
    "group": "all|regular_play|combo"
  },
  "891": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & gelijkspel",
    "1896": "{%player} & {$competitor2}",
    "1897": "ander",
    "name": "{!goalnr} doelpuntenmaker & 1x2",
    "group": "all|regular_play|combo"
  },
  "894": {
    "1923": "7:0",
    "1924": "7:1",
    "1925": "7:2",
    "1926": "7:3",
    "1927": "7:4",
    "1928": "7:5",
    "1929": "ander {$competitor1} win",
    "1930": "0:7",
    "1931": "1:7",
    "1932": "2:7",
    "1933": "3:7",
    "1934": "4:7",
    "1935": "5:7",
    "1936": "ander {$competitor2} win",
    "name": "{!setnr} set tiebreak - juiste score",
    "group": "all|score|tiebreak"
  },
  "895": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set tiebreak - totaal aantal punten",
    "group": "all|score|tiebreak"
  },
  "896": {
    "1937": "schot",
    "1938": "kopbal",
    "1939": "eigen doelpunt",
    "1940": "strafschop",
    "1941": "vrije trap",
    "1942": "geen",
    "name": "{!scorenr} scoringstype",
    "group": "all|score|regular_play"
  },
  "897": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "ander",
    "name": "Extra tijd- juiste score",
    "group": "all|score|ot"
  },
  "902": {
    "1640": "{$competitor1} met try",
    "1641": "{$competitor1} met penalty",
    "1642": "{$competitor1} met drop goal",
    "1643": "{$competitor2} met try",
    "1644": "{$competitor2} met penalty",
    "1645": "{$competitor2} met drop goal",
    "name": "Volgende scoringsspel",
    "group": "all|score|regular_play"
  },
  "903": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Volgende score (incl. extra tijd)",
    "group": "all|score|incl_ot"
  },
  "904": {
    "1945": "touchdown",
    "1946": "veldgoal",
    "1947": "safety",
    "1948": "geen",
    "name": "Volgende scoringstype (incl. extra tijd)",
    "group": "all|score|incl_ot"
  },
  "905": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "1e helft - volgende score",
    "group": "all|score|1st_half"
  },
  "911": {
    "74": "ja",
    "76": "nee",
    "name": "Zal de wedstrijd volledig worden uitgevochten (alle rondes)?",
    "group": "all"
  },
  "914": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal passing yards",
    "group": "all"
  },
  "915": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal aangekomen passes",
    "group": "all"
  },
  "916": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal passing touchdowns",
    "group": "all"
  },
  "917": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal carries",
    "group": "all"
  },
  "918": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal rushing yards",
    "group": "all"
  },
  "919": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal receiving yards",
    "group": "all"
  },
  "920": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal receptions",
    "group": "all"
  },
  "921": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal punten",
    "group": "all|score|incl_ot|player_props"
  },
  "922": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal assists",
    "group": "all|incl_ot|player_props|assist"
  },
  "923": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal rebounds",
    "group": "all|incl_ot|player_props|rebound"
  },
  "924": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal driepunter-veldgoals",
    "group": "all|score|incl_ot|player_props"
  },
  "925": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal werper strike-outs",
    "group": "all|incl_ei"
  },
  "926": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal honken",
    "group": "all|incl_ei"
  },
  "927": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal slagman runs + ingeslagen runs",
    "group": "all|incl_ei"
  },
  "928": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal runs verdiend",
    "group": "all|incl_ei"
  },
  "929": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total saves (incl. overtime)",
    "group": "all"
  },
  "931": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal touchdowns (incl. verlenging)",
    "group": "all|incl_ot"
  },
  "932": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal veldgoals (incl. verlenging)",
    "group": "all|incl_ot"
  },
  "933": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal turnovers (incl. verlenging)",
    "group": "all"
  },
  "934": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal sacks (incl. verlenging)",
    "group": "all"
  },
  "940": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{fieldgoalnr} veldgoal gescoord (incl. verlenging)",
    "group": "all"
  },
  "956": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{timeoutnr} timeout",
    "group": "all"
  },
  "959": {
    "1961": "veldgoal poging",
    "1962": "offensive touchdown",
    "1963": "punt",
    "1964": "turnover",
    "1965": "safety",
    "name": "{drivenr} drive - resultaat",
    "group": "all"
  },
  "960": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{quarternr} kwart - laatste punt",
    "group": "all"
  },
  "961": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{freethrownr} vrije worp gescoord",
    "group": "all"
  },
  "962": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal aantal maximum opeenvolgende punten",
    "group": "all"
  },
  "963": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal aantal maximum opeenvolgende punten",
    "group": "all"
  },
  "964": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Willekeurig team totaal aantal maximum opeenvolgende punten",
    "group": "all"
  },
  "965": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} staat {points} punten voor",
    "group": "all"
  },
  "966": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} staat {points} punten voor",
    "group": "all"
  },
  "967": {
    "74": "ja",
    "76": "nee",
    "name": "Willekeurig team staat {points} punten voor",
    "group": "all"
  },
  "970": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Totaal aantal zespunters spread",
    "group": "all"
  },
  "971": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Multi zespunters spread",
    "group": "all"
  },
  "972": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor1} 10/3 zespunters onderling spread",
    "group": "all"
  },
  "973": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor2} 10/3 zespunters onderling spread",
    "group": "all"
  },
  "974": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor1} totaal aantal zespunters spread",
    "group": "all"
  },
  "975": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor2} totaal aantal zespunters spread",
    "group": "all"
  },
  "976": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Totaal aantal vierpunters spread",
    "group": "all"
  },
  "977": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Multi vierpunters spread",
    "group": "all"
  },
  "978": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor1} totaal aantal vierpunters spread",
    "group": "all"
  },
  "979": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor2} totaal aantal vierpunters spread",
    "group": "all"
  },
  "980": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor1} joy van zespunter spread",
    "group": "all"
  },
  "981": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{$competitor2} joy van zespunter spread",
    "group": "all"
  },
  "982": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Totaal aantal {upsnr} ups spread",
    "group": "all"
  },
  "984": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor1} totaal aantal {upsnr} ups spread",
    "group": "all"
  },
  "985": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {$competitor2} totaal aantal {upsnr} ups spread",
    "group": "all"
  },
  "988": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs 0 tot {overnr} - {$competitor1} supremacy spread",
    "group": "all"
  },
  "989": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs 0 tot {overnr} - {$competitor2} supremacy spread",
    "group": "all"
  },
  "992": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Totaal aantal wides spread",
    "group": "all"
  },
  "993": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Multi wides spread",
    "group": "all"
  },
  "994": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings {overnr} over - totaal aantal runs spread",
    "group": "all"
  },
  "995": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Multi flyer spread",
    "group": "all"
  },
  "996": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Totaal aantal run outs spread",
    "group": "all"
  },
  "997": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Launch spread",
    "group": "all"
  },
  "998": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "Man van de wedstrijd spelerrendement spread",
    "group": "all"
  },
  "999": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{%player} totaal spelerrendement spread",
    "group": "all"
  },
  "1000": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs {overnrX} x {overnrY} - {$competitor1} multi run spread",
    "group": "all"
  },
  "1001": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings overs {overnrX} x {overnrY} - {$competitor2} multi run spread",
    "group": "all"
  },
  "1002": {
    "1890": "verkopen",
    "1891": "kopen",
    "1892": "mid",
    "name": "{inningnr} innings - {%player} {upsnr} ups spread",
    "group": "all"
  },
  "1006": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "2 ball (1x2)",
    "group": "all"
  },
  "1007": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "2 ball (handicap)",
    "group": "all"
  },
  "1008": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal aantal slagen {%competitor}",
    "group": "all"
  },
  "1010": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal aantal eagles {%competitor}",
    "group": "all"
  },
  "1011": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal aantal birdies {%competitor}",
    "group": "all"
  },
  "1012": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal aantal pars {%competitor}",
    "group": "all"
  },
  "1013": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal aantal bogeys {%competitor}",
    "group": "all"
  },
  "1014": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "totaal 2+ boven par {%competitor}",
    "group": "all"
  },
  "1016": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal eagles",
    "group": "all"
  },
  "1017": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal birdies",
    "group": "all"
  },
  "1018": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal pars",
    "group": "all"
  },
  "1019": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal bogeys",
    "group": "all"
  },
  "1020": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal 2+ boven par",
    "group": "all"
  },
  "1021": {
    "70": "oneven",
    "72": "even",
    "name": "oneven/even slagen {%competitor}",
    "group": "all"
  },
  "1023": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - 2 ball (1x2)",
    "group": "all"
  },
  "1024": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole {holenr} - 2 ball (handicap)",
    "group": "all"
  },
  "1025": {
    "74": "ja",
    "76": "nee",
    "name": "Hole {holenr} - willekeurige speler onder par",
    "group": "all"
  },
  "1026": {
    "74": "ja",
    "76": "nee",
    "name": "Hole {holenr} - {%competitor} onder par",
    "group": "all"
  },
  "1028": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Holes {from} tot {to} - 2 ball (1x2)",
    "group": "all"
  },
  "1029": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Holes {from} tot {to} - 2 ball (handicap)",
    "group": "all"
  },
  "1030": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Holes {from} tot {to} - 2 ball (1x2) meeste birdies",
    "group": "all"
  },
  "1031": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Holes {from} tot {to} - 2 ball (1x2) meeste pars",
    "group": "all"
  },
  "1032": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Holes {from} tot {to} - 2 ball (1x2) meeste bogeys",
    "group": "all"
  },
  "1036": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "gelijkspel ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{quarternr} kwart - handicap {hcp}",
    "group": "all"
  },
  "1037": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Race naar {goals} goals",
    "group": "all"
  },
  "1040": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal slagen (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1041": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} totaal aantal slagen (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1042": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} totaal aantal slagen (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1043": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - totaal aantal slagen",
    "group": "all"
  },
  "1044": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - {$competitor1} totaal aantal slagen",
    "group": "all"
  },
  "1045": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - {$competitor2} totaal aantal slagen",
    "group": "all"
  },
  "1046": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Innings 1 tot 5 - totaal aantal slagen",
    "group": "all"
  },
  "1047": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Innings 1 tot 5 - {$competitor1} totaal aantal slagen",
    "group": "all"
  },
  "1048": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Innings 1 tot 5 - {$competitor2} totaal aantal slagen",
    "group": "all"
  },
  "1049": {
    "1978": "slag",
    "1979": "wijd",
    "1980": "geraakt",
    "1981": "overig",
    "name": "Resultaat van {!pitchnr} worp",
    "group": "all|rapid_market|pitch"
  },
  "1050": {
    "74": "ja",
    "76": "nee",
    "name": "Geraakt bij {!pitchnr} worp",
    "group": "all|rapid_market|pitch"
  },
  "1051": {
    "74": "ja",
    "76": "nee",
    "name": "Homerun bij {!pitchnr} worp",
    "group": "all|rapid_market|pitch"
  },
  "1052": {
    "1982": "enkel",
    "1983": "dubbel",
    "1984": "triple",
    "1985": "homerun",
    "1986": "geen slag meer",
    "name": "Resultaat van {!hitnr} slag",
    "group": "all|rapid_market|hit"
  },
  "1053": {
    "1987": "op het honk",
    "1988": "uit",
    "1989": "homerun",
    "name": "Resultaat van {%player} {!appearancenr} keer aan slag",
    "group": "all|player|rapid_market"
  },
  "1054": {
    "74": "ja",
    "76": "nee",
    "name": "{%player} uitgeworpen {!appearancenr} keer aan slag",
    "group": "all|player|rapid_market"
  },
  "1055": {
    "973": "{$competitor1} & boven {total}",
    "974": "{$competitor2} & boven {total}",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Winnaar & totaal",
    "group": "all|regular_play|combo"
  },
  "1056": {
    "973": "{$competitor1} & boven {total}",
    "974": "{$competitor2} & boven {total}",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "{setnr} set - winnaar & totaal",
    "group": "all|combo|set"
  },
  "1057": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{quarternr} kwart - race naar {pointnr} punten",
    "group": "all|score|quarter"
  },
  "1061": {
    "1990": "rush",
    "1991": "pass",
    "name": "{!drivenr} drive play {playnr} - {%competitor} play type",
    "group": "all|drive"
  },
  "1062": {
    "74": "ja",
    "76": "nee",
    "name": "{!drivenr} drive play {playnr} - {%competitor} pass completion",
    "group": "all|drive"
  },
  "1063": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!drivenr} drive play {playnr} - {%competitor} totaal aantal yards gewonnen",
    "group": "all|drive"
  },
  "1064": {
    "74": "ja",
    "76": "nee",
    "name": "{!drivenr} drive play {playnr} - {%competitor} new first down",
    "group": "all|drive"
  },
  "1065": {
    "74": "ja",
    "76": "nee",
    "name": "{!drivenr} drive play {playnr} - {%competitor} sack",
    "group": "all|drive"
  },
  "1066": {
    "1992": "punt",
    "1993": "touchdown",
    "1994": "veldgoal poging",
    "1995": "anders",
    "name": "{!drivenr} drive - {%competitor} resultaat",
    "group": "all|drive"
  },
  "1067": {
    "973": "{$competitor1} & boven {total}",
    "974": "{$competitor2} & boven {total}",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Winnaar & totaal (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1068": {
    "74": "ja",
    "76": "nee",
    "name": "Zal er een grand slam gescoord worden (incl. extra innings)?",
    "group": "all|incl_ei"
  },
  "1069": {
    "74": "ja",
    "76": "nee",
    "name": "Willekeurig team houdt de nul (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1070": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} inning - meeste slagballen",
    "group": "all"
  },
  "1071": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} inning - meeste wijdballen",
    "group": "all"
  },
  "1072": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{inningnr} inning - meeste slagen",
    "group": "all"
  },
  "1073": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{inningnr} inning - exact aantal homeruns",
    "group": "all"
  },
  "1074": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{inningnr} inning - exact aantal homeruns {$competitor1}",
    "group": "all"
  },
  "1075": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{inningnr} inning - exact aantal homeruns {$competitor2}",
    "group": "all"
  },
  "1076": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - totaal aantal worpen",
    "group": "all"
  },
  "1077": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - totaal aantal worpen {$competitor1}",
    "group": "all"
  },
  "1078": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{inningnr} inning - totaal aantal worpen {$competitor2}",
    "group": "all"
  },
  "1079": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{inningnr} inning - exact aantal strike-outs {$competitor1}",
    "group": "all"
  },
  "1080": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{inningnr} inning - exact aantal strike-outs {$competitor2}",
    "group": "all"
  },
  "1081": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} inning - {$competitor1} maakt een double of triple play",
    "group": "all"
  },
  "1082": {
    "74": "ja",
    "76": "nee",
    "name": "{inningnr} inning - {$competitor2} maakt een double of triple play",
    "group": "all"
  },
  "1083": {
    "2005": "1-3",
    "2006": "4-5",
    "2007": "6+",
    "name": "Worpbereik van {%player} {appearancenr} keer aan slag",
    "group": "all"
  },
  "1084": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "Exact aantal slagballen van {%player} {appearancenr} keer aan slag",
    "group": "all"
  },
  "1085": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "Exact aantal wijdballen van {%player} {appearancenr} keer aan slag",
    "group": "all"
  },
  "1086": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totale snelheid van {pitchnr} worp",
    "group": "all"
  },
  "1087": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "exact aantal homeruns (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1088": {
    "2008": "{$competitor1} eenpunter",
    "2009": "{$competitor1} tweepunter",
    "2010": "{$competitor1} driepunter",
    "2011": "{$competitor2} eenpunter",
    "2012": "{$competitor2} tweepunter",
    "2013": "{$competitor2} driepunter",
    "name": "Scoringstype {pointnr} punt (incl. extra tijd)",
    "group": "all"
  },
  "1089": {
    "2014": "Eenpunter",
    "2015": "Tweepunter",
    "2016": "Driepunter",
    "name": "Willekeurig team scoringstype {pointnr} punt (incl. extra tijd)",
    "group": "all"
  },
  "1090": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{quarternr} kwart - {pointnr} punt",
    "group": "all"
  },
  "1096": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal rondes bij {stopnr}e pitstop",
    "group": "all"
  },
  "1097": {
    "2017": "1-2",
    "2018": "3-4",
    "2019": "5-6",
    "2020": "7-8",
    "2021": "9-10",
    "2022": "11+",
    "name": "Startpositie van de uiteindelijke winnaar",
    "group": "all"
  },
  "1098": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Aantal inhaalmanoeuvres {%competitor}",
    "group": "all"
  },
  "1099": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal finishers",
    "group": "all"
  },
  "1100": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal inhaalmanoeuvres",
    "group": "all"
  },
  "1106": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Aantal inhaalmanoeuvres {%team}",
    "group": "all"
  },
  "1108": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{lapnr}e ronde - totaal aantal terugtrekkingen",
    "group": "all"
  },
  "1119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Race naar {pointnr} punten",
    "group": "all"
  },
  "1120": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal homeruns (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1121": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal homeruns {$competitor1} (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1122": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Totaal aantal homeruns {$competitor2} (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!inningnr}e inning - Winnaar",
    "group": "all|inning"
  },
  "1124": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Innings 1 tot 5 - Winnaar",
    "group": "all|5_innings"
  },
  "1125": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings - {%player1} scoort {milestone} & {%player2} {total} + dismissals",
    "group": "all"
  },
  "1127": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings - {%player1} scoort {milestone1} & {%player2} scoort {milestone2}",
    "group": "all"
  },
  "1128": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings - {%player1} & {%player2} scoren {milestone} & {%player3} {total} + dismissals",
    "group": "all"
  },
  "1129": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player1} + {%player2} totaal",
    "group": "all"
  },
  "1130": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player1} + {%player2} + {%player3} totaal",
    "group": "all"
  },
  "1131": {
    "74": "ja",
    "76": "nee",
    "name": "Beide teams scoren {milestone}",
    "group": "all"
  },
  "1132": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningsnr} innings over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor1} {total} +",
    "group": "all"
  },
  "1133": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningsnr} innings over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor2} {total} +",
    "group": "all"
  },
  "1134": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{!inningnr} innings - {%player1} & {%player2} dismissal-methode",
    "group": "all"
  },
  "1135": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Welk team heeft de hoogste 1e partnership & 1e over & overs 0 tot {overnr}",
    "group": "all"
  },
  "1136": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "ander",
    "name": "{!inningnr} innings over {overnr} - {deliverynr} delivery {$competitor1} exact aantal runs",
    "group": "all"
  },
  "1137": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "ander",
    "name": "{!inningnr} innings over {overnr} - {deliverynr} delivery {$competitor2} exact aantal runs",
    "group": "all"
  },
  "1138": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {deliverynr} delivery {$competitor1} is een wicket",
    "group": "all"
  },
  "1139": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {deliverynr} delivery {$competitor2} is een wicket",
    "group": "all"
  },
  "1140": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "ander",
    "name": "{!inningnr} innings - {%player1} of {%player2} dismissal-methode",
    "group": "all"
  },
  "1141": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} slaan een boundary",
    "group": "all"
  },
  "1142": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} {total} +",
    "group": "all"
  },
  "1143": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} scoort een boundary vier & een zes",
    "group": "all"
  },
  "1144": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} scoort een boundary vier & een zes",
    "group": "all"
  },
  "1145": {
    "74": "ja",
    "76": "nee",
    "name": "{!inningnr} innings - {%player1} of {%player2} overleeft een review",
    "group": "all"
  },
  "1146": {
    "2023": "{%player1}",
    "2024": "geen",
    "2025": "{%player2}",
    "name": "{!inningnr} innings - race naar {runs} runs",
    "group": "all"
  },
  "1147": {
    "74": "ja",
    "76": "nee",
    "name": "{%player} scoort {milestone} & neemt een wicket & een vangbal",
    "group": "all"
  },
  "1148": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{overnr} over - {$competitor1} totaal ({ballcount} ball)",
    "group": "all"
  },
  "1149": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{overnr} over - {$competitor2} totaal ({ballcount} ball)",
    "group": "all"
  },
  "1150": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Overs 0 tot {overnr} - {$competitor1} totaal ({ballcount} ball)",
    "group": "all"
  },
  "1151": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Overs 0 tot {overnr} - {$competitor2} totaal ({ballcount} ball)",
    "group": "all"
  },
  "1152": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} totaal aantal rushing touchdowns (incl. overtime)",
    "group": "all"
  },
  "1158": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "2 ball",
    "group": "all"
  },
  "1160": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Draw no bet",
    "group": "all"
  },
  "1161": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "1162": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole handicap",
    "group": "all"
  },
  "1163": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%competitor} total holes won",
    "group": "all"
  },
  "1165": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Total holes played",
    "group": "all"
  },
  "1166": {
    "74": "ja",
    "76": "nee",
    "name": "Will there be a tie",
    "group": "all"
  },
  "1168": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - head2head (1x2)",
    "group": "all"
  },
  "1169": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Hole {holenr} - draw no bet",
    "group": "all"
  },
  "1170": {
    "1966": "{%competitor1}",
    "1967": "gelijk",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - head2head (1x2)",
    "group": "all"
  },
  "1171": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Holes {from} to {to} - draw no bet",
    "group": "all"
  },
  "1173": {
    "973": "{$competitor1} & boven {total}",
    "974": "{$competitor2} & boven {total}",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Winner (including OT) & Total (including OT)",
    "group": "all"
  },
  "1174": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "Handicap (including OT) & Total (including OT)",
    "group": "all|combo|incl_ot"
  },
  "1175": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "1st quarter 1x2 & 1st quarter total",
    "group": "all|combo|incl_ot"
  },
  "1176": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st quarter handicap & 1st quarter total",
    "group": "all|combo|incl_ot"
  },
  "1177": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & boven {total}",
    "798": "X & {total} -",
    "800": "X & boven {total}",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & boven {total}",
    "name": "1st half 1x2 & 1st half total",
    "group": "all|combo|incl_ot"
  },
  "1178": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st half handicap & 1st half total",
    "group": "all|combo|incl_ot"
  },
  "1179": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st Half Result or Match Result",
    "group": "all|regular_play"
  },
  "1183": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total shots (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1185": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total shots on goal (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1187": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total passes (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1189": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total tackles (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1193": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Highest scoring quarter - total",
    "group": "all|score|regular_play"
  },
  "1195": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Lowest scoring quarter - total",
    "group": "all|score|regular_play"
  },
  "1197": {
    "74": "ja",
    "76": "nee",
    "name": "Any team to win both halves",
    "group": "all|score|regular_play"
  },
  "1199": {
    "74": "ja",
    "76": "nee",
    "name": "Any team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1201": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Team to win both halves",
    "group": "all|score|regular_play"
  },
  "1203": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1207": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Next {!breaknr} break",
    "group": "all"
  },
  "1209": {
    "2039": "{$competitor1} 6-0, 6-1, 6-2",
    "2040": "{$competitor1} 6-3, 6-4",
    "2041": "{$competitor1} 7-5, 7-6",
    "2042": "{$competitor2} 6-0, 6-1, 6-2",
    "2043": "{$competitor2} 6-3, 6-4",
    "2044": "{$competitor2} 7-5, 7-6",
    "name": "{!setnr} set - exact score group",
    "group": "all"
  },
  "1211": {
    "74": "ja",
    "76": "nee",
    "name": "Match to end {score}",
    "group": "all"
  },
  "1214": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} total deliveries faced",
    "group": "all"
  },
  "1215": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} runs conceded",
    "group": "all"
  },
  "1218": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor1} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1219": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor2} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1220": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Total batsman milestones (50s/100s)",
    "group": "all"
  },
  "1221": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{!inningnr} innings - {$competitor1} {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1222": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{!inningnr} innings - {$competitor2} {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1229": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} total",
    "group": "all"
  },
  "1230": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} total",
    "group": "all"
  },
  "1231": {
    "74": "ja",
    "76": "nee",
    "name": "Sum of bonus balls exact number",
    "group": "all"
  },
  "1242": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to home {homepoints} and away {awaypoints} points",
    "group": "all"
  },
  "1243": {
    "74": "ja",
    "76": "nee",
    "name": "Anytime exact score {homepoints}:{awaypoints}",
    "group": "all"
  },
  "1244": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "King of the Oche (Match Treble)",
    "group": "all"
  },
  "1246": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Player with highest checkout",
    "group": "all"
  },
  "1248": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Highest checkout in match",
    "group": "all"
  },
  "1250": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Total {points}+ checkouts",
    "group": "all"
  },
  "1252": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Match winner & highest checkout",
    "group": "all"
  },
  "1254": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Match winner & most 180s",
    "group": "all"
  },
  "1256": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "Highest checkout & most 180s",
    "group": "all"
  },
  "1258": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "To lead after {!legnr} leg",
    "group": "all"
  },
  "1260": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!legnr} leg checkout total",
    "group": "all"
  },
  "1264": {
    "74": "ja",
    "76": "nee",
    "name": "170 checkout in match",
    "group": "all"
  },
  "1269": {
    "74": "ja",
    "76": "nee",
    "name": "{!setnr} set game {gamenr} - ace",
    "group": "all|micro_market"
  },
  "1270": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!acenr} ace",
    "group": "all|micro_market"
  },
  "1271": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total points",
    "group": "all|player_props"
  },
  "1272": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total points",
    "group": "all|player_props"
  },
  "1273": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total breaks",
    "group": "all|player_props"
  },
  "1274": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total aces",
    "group": "all|player_props"
  },
  "1275": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total aces",
    "group": "all|player_props"
  },
  "1276": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - most aces",
    "group": "all|player_props"
  },
  "1277": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total breaks",
    "group": "all|player_props"
  },
  "1278": {
    "74": "ja",
    "76": "nee",
    "name": "Both players to win a set",
    "group": "all|score|regular_play"
  },
  "1279": {
    "2047": "4:0",
    "2048": "3:1",
    "2049": "2:2",
    "2050": "1:3",
    "2051": "0:4",
    "name": "{!setnr} set - correct score after 4 games",
    "group": "all|score|set"
  },
  "1280": {
    "2052": "6:0",
    "2053": "5:1",
    "2054": "4:2",
    "2055": "3:3",
    "2056": "2:4",
    "2057": "1:5",
    "2058": "0:6",
    "name": "{!setnr} set - correct score after 6 games",
    "group": "all|score|set"
  },
  "1281": {
    "6": "{$competitor1}",
    "7": "geen",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!breaknr} break",
    "group": "all|score|set|micro_market"
  },
  "1282": {
    "74": "ja",
    "76": "nee",
    "name": "{!setnr} set game {gamenr} - break point",
    "group": "all|score|game|micro_market"
  },
  "1283": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Booking handicap",
    "group": "all|regular_play|bookings"
  },
  "1284": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Overtime 1st half - total",
    "group": "all|score|ot_1st_half"
  },
  "1285": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} total points",
    "group": "all|score|regular_play|player_props"
  },
  "1286": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} total points",
    "group": "all|score|regular_play|player_props"
  },
  "1287": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} total breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1288": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} total breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1289": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} total aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1290": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} total aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1291": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1292": {
    "2059": "point after rally",
    "2060": "ace",
    "2061": "double fault",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point serve outcome",
    "group": "all|score|points|micro_market"
  },
  "1293": {
    "2064": "{$competitor1} winner",
    "2065": "{$competitor2} winner",
    "2066": "{$competitor1} error",
    "2067": "{$competitor2} error",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point outcome",
    "group": "all|score|points|micro_market"
  },
  "1294": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point total shots",
    "group": "all|score|points|micro_market"
  },
  "1295": {
    "2068": "serve",
    "2069": "return",
    "2070": "forehand",
    "2071": "backhand",
    "2072": "volley",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point last stroke",
    "group": "all|score|points|micro_market"
  },
  "1296": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Total yellow cards",
    "group": "all|regular_play|bookings"
  },
  "1297": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "Total red cards",
    "group": "all|regular_play|bookings"
  },
  "1298": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Yellow card 1x2",
    "group": "all|regular_play|bookings"
  },
  "1299": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Yellow card handicap",
    "group": "all|regular_play|bookings"
  },
  "1300": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total points (incl. overtime)",
    "group": "all"
  },
  "1301": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total assists (incl. overtime)",
    "group": "all"
  },
  "1302": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total rebounds (incl. overtime)",
    "group": "all"
  },
  "1303": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total 3-point field goals (incl. overtime)",
    "group": "all"
  },
  "1304": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{%player} total points + rebounds + assists (incl. overtime)",
    "group": "all|combo|incl_ot|player_props"
  },
  "1305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st half - {points} point score draw no bet",
    "group": "all|score|1st_half|micro_market"
  },
  "1306": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd half - {points} point score draw no bet",
    "group": "all|score|2nd_half|micro_market"
  },
  "1307": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {points} point score draw no bet",
    "group": "all|score|quarter|micro_market"
  },
  "1308": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1309": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1310": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1311": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1312": {
    "2073": "score",
    "2074": "no score",
    "name": "{!possessionnr} possession outcome",
    "group": "all|score|regular_play|micro_market"
  },
  "1313": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor1} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1314": {
    "74": "ja",
    "76": "nee",
    "name": "{$competitor2} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1315": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor1} total double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1316": {
    "12": "boven {total}",
    "13": "{total} -",
    "name": "{$competitor2} total double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1500": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rest of Total match",
    "group": "all"
  },
  "1601": {
    "16001": "{$competitor1} & 2-3 goals",
    "16002": "{$competitor1} & 2-4 goals",
    "16003": "{$competitor1} & 2-5 goals",
    "16004": "{$competitor1} & 3-4 goals",
    "16005": "{$competitor1} & 3-5 goals",
    "16006": "{$competitor1} & 3-6 goals",
    "16007": "draw & 2-3 goals",
    "16008": "draw & 2-4 goals",
    "16009": "draw & 2-5 goals",
    "16010": "draw & 3-4 goals",
    "16011": "draw & 3-5 goals",
    "16012": "draw & 3-6 goals",
    "16013": "{$competitor2} & 2-3 goals",
    "16014": "{$competitor2} & 2-4 goals",
    "16015": "{$competitor2} & 2-5 goals",
    "16016": "{$competitor2} & 3-4 goals",
    "16017": "{$competitor2} & 3-5 goals",
    "16018": "{$competitor2} & 3-6 goals",
    "name": "1x2 & Multigoals",
    "group": "all"
  },
  "1602": {
    "16021": "{$competitor1} or draw & 2-3 goals",
    "16022": "{$competitor1} or draw & 2-4 goals",
    "16023": "{$competitor1} or draw & 2-5 goals",
    "16024": "{$competitor1} or draw & 3-4 goals",
    "16025": "{$competitor1} or draw & 3-5 goals",
    "16026": "{$competitor1} or draw & 3-6 goals",
    "16027": "{$competitor1} or {$competitor2} & 2-3 goals",
    "16028": "{$competitor1} or {$competitor2} & 2-4 goals",
    "16029": "{$competitor1} or {$competitor2} & 2-5 goals",
    "16030": "{$competitor1} or {$competitor2} & 3-4 goals",
    "16031": "{$competitor1} or {$competitor2} & 3-5 goals",
    "16032": "{$competitor1} or {$competitor2} & 3-6 goals",
    "16033": "draw or {$competitor2} & 2-3 goals",
    "16034": "draw or {$competitor2} & 2-4 goals",
    "16035": "draw or {$competitor2} & 2-5 goals",
    "16036": "draw or {$competitor2} & 3-4 goals",
    "16037": "draw or {$competitor2} & 3-5 goals",
    "16038": "draw or {$competitor2} & 3-6 goals",
    "name": "Double chance & Multigoals",
    "group": "all"
  },
  "1603": {
    "16040": "0:0/1:1",
    "16041": "0:1/0:2/1:2",
    "16042": "0:3/1:3/2:3",
    "16043": "1:0/2:0/2:1",
    "16044": "1:4/2:4/3:4",
    "16045": "2:2/3:3/4:4",
    "16046": "3:0/3:1/3:2",
    "16047": "4:1/4:2/4:3",
    "16048": "4:0/0:4/Other",
    "name": "Multiscore-3",
    "group": "all"
  },
  "1604": {
    "16050": "0:0/1:1/0:1/1:0",
    "16051": "0:2/1:2/0:3/1:3",
    "16052": "0:4/1:4/2:4/3:4",
    "16053": "2:0/2:1/3:0/3:1",
    "16054": "2:2/2:3/3:2/3:3",
    "16055": "4:0/4:1/4:2/4:3",
    "16056": "4:4/Other",
    "name": "Multiscore-4",
    "group": "all"
  },
  "1605": {
    "16057": "{$competitor1} or no",
    "16058": "{$competitor1} or yes",
    "16059": "{$competitor2} or no",
    "16060": "{$competitor2} or yes",
    "16061": "draw or no",
    "16062": "draw or yes",
    "name": "1x2 or both teams to score",
    "group": "all"
  },
  "1606": {
    "16063": "{$competitor1}/draw / {$competitor1}/draw",
    "16064": "{$competitor1}/draw / {$competitor1}/{$competitor2}",
    "16065": "{$competitor1}/draw / draw/{$competitor2}",
    "16066": "{$competitor1}/{$competitor2} / {$competitor1}/draw",
    "16067": "{$competitor1}/{$competitor2} / draw/{$competitor2}",
    "16068": "draw/{$competitor2} / {$competitor1}/draw",
    "16069": "{$competitor1}/{$competitor2} / {$competitor1}/{$competitor2}",
    "16070": "draw/{$competitor2} / {$competitor1}/{$competitor2}",
    "16071": "draw/{$competitor2} / draw/{$competitor2}",
    "name": "Double chance Halftime/Fulltime",
    "group": "all"
  },
  "1607": {
    "16072": "{$competitor1} or {total} over",
    "16073": "draw or {total} over",
    "16074": "{$competitor2} or {total} over",
    "16075": "{$competitor1} or {total} under",
    "16076": "draw or {total} under",
    "16077": "{$competitor2} or {total} under",
    "name": "1x2 or {total} total",
    "group": "all"
  },
  "1608": {
    "16078": "yes or {total} over",
    "16079": "yes or {total} under",
    "16080": "no or {total} over",
    "16081": "no or {total} under",
    "name": "Both team to score or {total} total",
    "group": "all"
  },
  "1609": {
    "16082": "{$competitor1} and yes and {total} over",
    "16083": "{$competitor1} and no and {total} over",
    "16084": "{$competitor1} and no and {total} under",
    "16085": "draw and yes and {total} over",
    "16086": "draw and yes and {total} under",
    "16087": "draw and no and {total} under",
    "16088": "{$competitor2} and yes and {total} over",
    "16089": "{$competitor2} and no and {total} over",
    "16090": "{$competitor2} and no and {total} under",
    "name": "1x2 and Both team to score and {total} total",
    "group": "all"
  },
  "1610": {
    "16091": "<1 and <1",
    "16092": ">=1 and >=1",
    "16093": "<1 and <2",
    "16094": ">=1 and >=2",
    "16095": "<1 and <3",
    "16096": ">=1 and >=3",
    "16097": "<2 and <1",
    "16098": ">=2 and >=1",
    "16099": "<2 and <2",
    "16100": ">=2 and >=2",
    "16101": "<2 and <3",
    "16102": ">=2 and >=3",
    "16103": "<3 and <1",
    "16104": ">=3 and >=1",
    "16105": ">=3 and >=2",
    "16106": ">=3 and >=3",
    "name": "Exact goals in HT/2HT",
    "group": "all"
  },
  "1612": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 5 minutes",
    "group": "all"
  },
  "1613": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 10 minutes",
    "group": "all"
  },
  "1614": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 15 minutes",
    "group": "all"
  },
  "1615": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 20 minutes",
    "group": "all"
  },
  "1616": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 30 minutes",
    "group": "all"
  },
  "1617": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 60 minutes",
    "group": "all"
  },
  "1618": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 5 min",
    "group": "all"
  },
  "1619": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 10 min",
    "group": "all"
  },
  "1620": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 15 min",
    "group": "all"
  },
  "1621": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 20 min",
    "group": "all"
  },
  "1622": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 30 min",
    "group": "all"
  },
  "1623": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 60 min",
    "group": "all"
  },
  "1624": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 2 goals in a row",
    "group": "all"
  },
  "1625": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1626": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 2 goals in a row",
    "group": "all"
  },
  "1627": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 3 goals in a row",
    "group": "all"
  },
  "1628": {
    "74": "yes",
    "76": "no",
    "name": "Any 2 goals in a row",
    "group": "all"
  },
  "1629": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1630": {
    "74": "yes",
    "76": "no",
    "name": "Both team to score 2+",
    "group": "all"
  },
  "1631": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Halftime or fulltime",
    "group": "all"
  },
  "1632": {
    "1724": "{$competitor1}/draw & {total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "draw/{$competitor2} & {total} -",
    "1727": "{$competitor1}/draw & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "draw/{$competitor2} & {total} +",
    "name": "1st half - Double chance and Total Halftime or Fulltime",
    "group": "all"
  },
  "1633": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "Double chance (1st half) & 1x2",
    "group": "all"
  },
  "1634": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "1x2 (1st half) & Double chance",
    "group": "all"
  }
};

export const global_marketname = {
  "1": "Winnaar",
  "7": "Rest van de Match",
  "8": "Volgende Goal",
  "10": "Dubelle Kans",
  "18": "Over/Onder",
  "19": "Thuis Totaal",
  "20": "Uit Totaal",
  "186": "Winnaar",
  "219": "12 Inclusief overwerk",
  "225": "Under/Over Including Overtime",
  "251": "Winnaar",
  "258": "Under/Over Including Overtime",
  "340": "Winnaar"
};
